<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="客户" class="mb-0">
							<el-select v-model="from.name" size="small" clearable filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('accountList.ac_id')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						<!-- <el-form-item :label="$t('accountList.isFp')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.yes')" :value="1"></el-option>
								<el-option :label="$t('accountList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item> -->
						
						<!-- <el-form-item :label="$t('acapplyList.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('acapplyList.dai')" :value="0"></el-option>
								<el-option :label="$t('acapplyList.yes')" :value="1"></el-option>
								<el-option :label="$t('acapplyList.no')" :value="2"></el-option>
								<el-option :label="$t('acapplyList.close')" :value="3"></el-option>
								
							</el-select>
						</el-form-item> -->
						<el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('monList.mon')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="month"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						<el-form-item label="供应商" class="mb-0">
							<el-select v-model="from.supplier_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('new1.sup')" class="mb-0">
							<el-select v-model="from.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('orderList.addOrder')}}</el-button>
						
						<el-dropdown v-if="canExportBillExcel()"  @command="downExcel" class="ml-2">
						  <el-button type="success" icon="el-icon-download" size="small">
						    {{$t('new1.excel')}}<i class="el-icon-arrow-down el-icon--right"></i>
						  </el-button>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item command="all">{{$t('new1.excelall')}}</el-dropdown-item>
						    <el-dropdown-item command="sel">{{$t('new1.excelsel')}}</el-dropdown-item>
							<el-dropdown-item command="set">{{$t('new1.excelset')}}</el-dropdown-item>
						   
						  </el-dropdown-menu>
						</el-dropdown>
						<!-- <el-button v-auth="'other'+auth_val" class="ml-2"  type="primary" size="small" @click="openOtherModel"  >{{$t('new1.tousd')}}</el-button>
						
						
						<el-button v-auth="'other'+auth_val" class="ml-2"  type="warning" size="small" @click="openAgainModel"  >{{$t('monList.againGet')}}</el-button>
						
						 -->
						<el-dropdown trigger="hover" @command="selMore">
						<el-button v-auth="'other'+auth_val" class="ml-3" type="" size="small">
							{{$t('new1.more')}}<i class="el-icon-arrow-down el-icon--right"></i>
						  </el-button>
						
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="huan">{{$t('new1.tousd')}}</el-dropdown-item>
							<el-dropdown-item command="again">{{$t('monList.againGet')}}</el-dropdown-item>
							<el-dropdown-item command="tl">{{$t('new1.tlOdds')}}</el-dropdown-item>
						</el-dropdown-menu>
						</el-dropdown>
						
						
						<el-tag type="success" class="ml-3">
							总账单金额：<strong>{{total.order}}</strong>
						</el-tag>
						
						<el-tag type="warning" class="ml-3">
							总合计消费：<strong>{{total.total}}</strong>
						</el-tag>
						
						
						
						<el-button type="warning" class="ml-2" size="small" @click="checkAgain()"  >当前重拉</el-button>
						<el-badge v-if="canUseManualCost()" :is-dot="true" :hidden="!billConfirm.has_diff" class="ml-2 bill-confirm-badge">
							<el-button type="primary" size="small" :loading="billConfirm.loading" @click="openBillConfirmModel()">
								数据确定
							</el-button>
						</el-badge>
						<el-button v-if="canUseManualCost()" type="warning" class="ml-2" size="small" v-auth="'other'+auth_val" @click="openPendingServerPriceList()"  >待定价</el-button>
						<el-button v-if="canUseManualCost()" type="primary" class="ml-2" size="small" @click="openManualCostModel()"  >成本录入</el-button>
						
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" row-class-name="bill-level-1-row" @selection-change="handleSelectionChange" @expand-change="openTable">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				
				<el-table-column
				     type="selection"
				     width="45">
				   </el-table-column>
				
				<el-table-column  align="center" type="index"  :label="$t('adminList.sort')" width="60">
				</el-table-column>
				
				<el-table-column  type="expand" :label="$t('status.log')">
				     <template slot-scope="props">
				       <el-table @expand-change="openTable2" v-loading="props.row.load" class="noth" stripe  :data="props.row.data" row-class-name="bill-level-2-row" style="width: 100%;padding-left: 105px;" >
						   
						   <el-table-column  type="expand" :label="$t('status.log')">
							   <template slot-scope="props2">
								   <el-table  v-loading="props2.row.load" class="noth" stripe  :data="props2.row.data" row-class-name="bill-level-3-row" @expand-change="openTable3" style="width: 100%;" >
									   
								<el-table-column  type="expand" :label="$t('status.log')">
									   	<template slot-scope="props3">
									   		<el-table  v-loading="props3.row.load" class="noth" stripe  :data="props3.row.data" row-class-name="bill-level-4-row" style="width: 100%;" @expand-change="openTable4">
												
		<!-- 第五层数据 -->
												
												
		<el-table-column  type="expand" :label="$t('status.log')">
				<template slot-scope="props4">
					<el-table  v-loading="props4.row.load" class="noth" stripe  :data="props4.row.data" row-class-name="bill-level-5-row" style="width: 100%;padding-left: 48px;" >
						
						
						<el-table-column align="center" width="140" prop="user_name" :label="$t('orderList.user')">								   													
						<template slot-scope="scope">
							<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
							
						</template>
						</el-table-column>
						
						
						<el-table-column align="center" width="100" prop="date" :label="$t('orderList.date')">
							<template slot-scope="scope">
								{{ props.row.date }}
							  </template>
						</el-table-column>
						
						
						<el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
							<template slot-scope="scope">
								{{ props2.row.cloud_name }}
								<i v-if="props3.row.is_rmb==1" class="text_chengse ml-1 iconfont icon-rmb-full"></i>
							  </template>
						</el-table-column>
						
						
						<el-table-column width="120" align="center" label="供应商">
						<template slot-scope="scope">
							{{ props3.row.provider_supplier_name || '-' }}
						  </template>
						</el-table-column>
						
						
						<el-table-column width="120" align="center" prop="cloud_name" :label="$t('new1.sup')">
						<template slot-scope="scope">
							{{ props3.row.sup_name }}
						  </template>
						</el-table-column>
						
						
						<el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
							<template slot-scope="scope">
								<div class="bill-account-cell">
									<span class="bill-account-name">{{ props3.row.ac_id }}</span>
									<el-tag v-if="props3.row.pay_type==2" type="warning" size="mini" class="bill-prepay-tag">预付费</el-tag>
								</div>
							</template>
						</el-table-column>
						
						
						<el-table-column width="120" align="center" prop="info" :label="$t('new1.protype')">
							<template slot-scope="scope">
								{{ props4.row.info }}
								
							</template>
						
						</el-table-column>
						
						<el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
							<template slot-scope="scope">
								<span>{{scope.row.pro_name}}</span>
								<el-tag v-if="scope.row.server_price_status==1" size="mini" type="warning" class="ml-1">待定价</el-tag>
							</template>
						</el-table-column>
						
						
						
						<el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
							
						
						</el-table-column>
						
						<el-table-column v-if="canUseManualCost()" width="120" align="center" prop="manual_cost_money" label="成本金额">
							<template slot-scope="scope">
								<span>{{ scope.row.manual_cost_money || '0.00' }}</span>
							</template>
						</el-table-column>
						
						<el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
						</el-table-column>
						
						
						<el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
							
						
						</el-table-column>
						
						<el-table-column  width="100" align="center" prop="odds" :label="$t('orderList.odds')">
							
						
						</el-table-column>
						
						
						
						<el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
							<template slot-scope="scope">
								<span class="text_chengse">{{scope.row.need_money}}</span>
							</template>
						</el-table-column>
						
						
						<el-table-column align="center"  width="120"  prop="is_ok" :label="$t('monList.confirmOrder')">
							<template slot-scope="scope">
								<span class="text-success"  v-if="props.row.is_ok==1">{{$t('monList.yes')}}</span>
								<span class="text-success"  v-if="props.row.is_ok==2">{{$t('monList.yes2')}}</span>
								<span style="color: #999;"  v-if="props.row.is_ok==0">{{$t('monList.no')}}</span>
								
							</template>
						</el-table-column>
						
						
						<el-table-column width="310"  prop="id" align="center" :label="$t('adminList.operation')">
							<template slot-scope="scope">
								<el-button-group>
									
										<el-button v-if="canDeleteServerBillDetail(scope.row,props.row,props3.row)"  :disabled="layout.loading" :loading="layout.loading" v-auth="'other'+auth_val"    @click="delLogLog(scope.row,props3.row)"  size="mini" plain type="danger">删除</el-button>
										<el-button :disabled="layout.loading" :loading="layout.loading" v-auth="'other'+auth_val" v-if="canFillPendingServerPrice(scope.row,props.row)"  @click="openPendingServerPrice(scope.row)"  size="mini" plain type="warning">补价格</el-button>
										<el-button :disabled="layout.loading" :loading="layout.loading" v-auth="'other'+auth_val" v-if="canAgainOdds(scope.row,props.row)"  @click="againOdds(scope.row)"  size="mini" plain type="info">{{$t('monList.againOdds')}}</el-button>
									
									
								
								</el-button-group>
							</template>
						</el-table-column>
						
					</el-table>
				</template>
			   </el-table-column>
												
												
												
												
												
												
												
												
									   			<!-- 第四层数据 -->
									   			
									   			<el-table-column align="center" width="140" prop="user_name" :label="$t('orderList.user')">								   													
												<template slot-scope="scope">
													<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
													
												</template>
									   			</el-table-column>
												
												
												<el-table-column align="center" width="100" prop="date" :label="$t('orderList.date')">
													<template slot-scope="scope">
														{{ props.row.date }}
													  </template>
												</el-table-column>
												
												
												<el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
													<template slot-scope="scope">
														{{ props2.row.cloud_name }}
														<i v-if="props3.row.is_rmb==1" class="text_chengse ml-1 iconfont icon-rmb-full"></i>
													  </template>
												</el-table-column>
												
												
												<el-table-column width="120" align="center" label="供应商">
												<template slot-scope="scope">
													{{ props3.row.provider_supplier_name || '-' }}
												  </template>
												</el-table-column>
												
												
												<el-table-column width="120" align="center" prop="cloud_name" :label="$t('new1.sup')">
												<template slot-scope="scope">
													{{ props3.row.sup_name }}
												  </template>
												</el-table-column>
												
												
												<el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
													<template slot-scope="scope">
														<div class="bill-account-cell">
															<span class="bill-account-name">{{ props3.row.ac_id }}</span>
															<el-tag v-if="props3.row.pay_type==2" type="warning" size="mini" class="bill-prepay-tag">预付费</el-tag>
														</div>
													</template>
												</el-table-column>
												
												
												<el-table-column width="120" align="center" prop="info" :label="$t('new1.protype')">
												
												</el-table-column>
												
												<el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
												</el-table-column>
												
												
												
												<el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
													
												
												</el-table-column>
												
												<el-table-column v-if="canUseManualCost()" width="120" align="center" prop="manual_cost_money" label="成本金额">
													<template slot-scope="scope">
														<span>{{ scope.row.manual_cost_money || '0.00' }}</span>
													</template>
												</el-table-column>
												
												<el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
												</el-table-column>
												
												
												<el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
													
												
												</el-table-column>
												
												<el-table-column  width="100" align="center" prop="odds" :label="$t('orderList.odds')">
													
												
												</el-table-column>
												
												
												
												<el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
													<template slot-scope="scope">
														<span class="text_chengse">{{scope.row.need_money}}</span>
													</template>
												</el-table-column>
												
												
												<el-table-column align="center"  width="120"  prop="is_ok" :label="$t('monList.confirmOrder')">
													<template slot-scope="scope">
														<span class="text-success"  v-if="props.row.is_ok==1">{{$t('monList.yes')}}</span>
														<span class="text-success"  v-if="props.row.is_ok==2">{{$t('monList.yes2')}}</span>
														<span style="color: #999;"  v-if="props.row.is_ok==0">{{$t('monList.no')}}</span>
														
													</template>
												</el-table-column>
												
												
												<el-table-column width="310"  prop="id" align="center" :label="$t('adminList.operation')">
													<template slot-scope="scope">
														<el-button-group>
															
															<el-button :disabled="layout.loading" :loading="layout.loading" v-auth="'other'+auth_val"    @click="copyOrder(scope.row)"  size="mini" plain type="warning">{{$t('monList.copyOrder')}}</el-button>
																<el-button :disabled="layout.loading" :loading="layout.loading" v-auth="'other'+auth_val" v-if="canFillPendingServerPrice(scope.row,props.row)"  @click="openPendingServerPrice(scope.row)"  size="mini" plain type="warning">补价格</el-button>
																<el-button :disabled="layout.loading" :loading="layout.loading" v-auth="'other'+auth_val" v-if="canAgainOdds(scope.row,props.row)"  @click="againOdds(scope.row)"  size="mini" plain type="info">{{$t('monList.againOdds')}}</el-button>
															
														
														</el-button-group>
													</template>
												</el-table-column>
												
												
									   		</el-table>
									   	</template>
									   </el-table-column>
									   
									   <!-- 第三层数据 -->
									   
									   <el-table-column align="center" width="140" prop="user_name" :label="$t('orderList.user')">
										   
										
										<template slot-scope="scope">
											<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
											
										</template>
									   </el-table-column>
									   
									   
									   
									   <el-table-column align="center" width="100" prop="date" :label="$t('orderList.date')">
										<template slot-scope="scope">
											{{ props.row.date }}
										  </template>
									   </el-table-column>
									   
									   
									   <el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
									   	<template slot-scope="scope">
									   		{{ scope.row.cloud_name }}
											<i v-if="scope.row.is_rmb==1" class="text_chengse ml-1 iconfont icon-rmb-full"></i>
									   	  </template>
									   </el-table-column>
									   
									   
									   <el-table-column width="120" align="center" label="供应商">
									   <template slot-scope="scope">
									   	{{ scope.row.provider_supplier_name || '-' }}
									     </template>
									   </el-table-column>
									   
									   
									   <el-table-column width="120" align="center" prop="cloud_name" :label="$t('new1.sup')">
									   <template slot-scope="scope">
									   	{{ scope.row.sup_name }}
									     </template>
									   </el-table-column>
									   
									   
									   
									   <el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
									   	<template slot-scope="scope">
									   		
											  <el-popover
											    placement="top-start"
												:title="$t('login.username')"
											    width="auto"
											    trigger="hover">
											    <div>{{ scope.row.username }}</div>
											    <div v-if="scope.row.live_user_name">推拉流用户：{{ scope.row.live_user_name }}</div>
											    <div v-if="confirmStage(scope.row)">数据确定：第{{ confirmStage(scope.row) }}次 {{ confirmDate(scope.row) }}</div>
											    <div slot="reference" class="bill-account-cell">
													<span v-if="scope.row.is_again==1" class="bill-account-icon"><i class="el-icon-refresh" style="color: green;font-weight: bold;font-size: 16px;"></i></span>
													<span class="bill-account-name">{{ scope.row.ac_id }}</span>
													<el-tag v-if="scope.row.pay_type==2" type="warning" size="mini" class="bill-prepay-tag">预付费</el-tag>
													<el-tag v-if="hasConfirmDiff(scope.row)" type="danger" size="mini" class="bill-prepay-tag">有变化</el-tag>
													<el-tag v-else-if="confirmStage(scope.row)" type="success" size="mini" class="bill-prepay-tag">已确定{{ confirmStage(scope.row) }}</el-tag>
												</div>
											  </el-popover>
									   	</template>
									   </el-table-column>
									   
									   <el-table-column width="120" align="center" prop="info" :label="$t('new1.protype')">
									   	<template slot-scope="scope">
									   		<span>{{$t('status.all')}}</span>
									   		
									   	</template>
									   </el-table-column>
									   
									   
									   <el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
									   	<template slot-scope="scope">
									   		<span>{{$t('status.all')}}</span>
									   		
									   	</template>
									   </el-table-column>
									   
									   
									   
									   <el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
									   	<template slot-scope="scope">
										   <el-tooltip placement="top">
											 <div slot="content">
												2号数据：{{scope.row.bc.order.m2}}<br/>
												4号数据：{{scope.row.bc.order.m4}}<br/>
												7号数据：{{scope.row.bc.order.m7}}<br/>
												<span v-for="item in confirmHistoryRows(scope.row,'order')" :key="'order-confirm-'+item.stage">
													第{{ item.stage }}次确定：{{ item.value }}<span v-if="item.date">（{{ item.date }}）</span><br/>
												</span>
												<span v-if="confirmFieldChanged(scope.row,'order')">变化：{{ confirmDiffValue(scope.row,'order') }}</span>
												 </div>
											 <span>{{scope.row.order_money}}</span>
										   </el-tooltip>

									   	</template>
									   
									   </el-table-column>
									   
									   <el-table-column v-if="canUseManualCost()" width="120" align="center" prop="manual_cost_money" label="成本金额">
									   	<template slot-scope="scope">
									   		<span>{{ scope.row.manual_cost_money || '0.00' }}</span>
									   	</template>
									   </el-table-column>
									   
									   
									   <el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
										   <template slot-scope="scope">
												   <el-tooltip placement="top">
													 <div slot="content">
														2号数据：{{scope.row.bc.total.m2}}<br/>
														4号数据：{{scope.row.bc.total.m4}}<br/>
														7号数据：{{scope.row.bc.total.m7}}<br/>
														<span v-for="item in confirmHistoryRows(scope.row,'total')" :key="'total-confirm-'+item.stage">
															第{{ item.stage }}次确定：{{ item.value }}<span v-if="item.date">（{{ item.date }}）</span><br/>
														</span>
														<span v-if="confirmFieldChanged(scope.row,'total')">变化：{{ confirmDiffValue(scope.row,'total') }}</span>
														 </div>
													 <span>{{scope.row.total}}</span>
												   </el-tooltip>

										   </template>
									   </el-table-column>
									   
									   
									   <el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
									   	
										<template slot-scope="scope">
										   <el-tooltip placement="top">
											 <div slot="content">
												2号数据：{{scope.row.bc.odds.m2}}<br/>
												4号数据：{{scope.row.bc.odds.m4}}<br/>
												7号数据：{{scope.row.bc.odds.m7}}<br/>
												<span v-for="item in confirmHistoryRows(scope.row,'odds')" :key="'odds-confirm-'+item.stage">
													第{{ item.stage }}次确定：{{ item.value }}<span v-if="item.date">（{{ item.date }}）</span><br/>
												</span>
												<span v-if="confirmFieldChanged(scope.row,'odds')">变化：{{ confirmDiffValue(scope.row,'odds') }}</span>
												 </div>
											 <span>{{scope.row.odds_money}}</span>
										   </el-tooltip>
										
										</template>
									   
									   </el-table-column>
									   
									   
									   <el-table-column  width="100" align="center" prop="odds" :label="$t('orderList.odds')">
									   	
									   
									   </el-table-column>
									   
									   
									   
									   <el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
									   	<template slot-scope="scope">
									   		<span class="text_chengse">{{scope.row.need_money}}</span>
									   	</template>
									   </el-table-column>
									   
									   
									   
									   <el-table-column align="center"  width="120"  prop="is_ok" :label="$t('monList.confirmOrder')">
									   	<template slot-scope="scope">
									   		<span class="text-success"  v-if="props.row.is_ok==1">{{$t('monList.yes')}}</span>
											<span class="text-success"  v-if="props.row.is_ok==2">{{$t('monList.yes2')}}</span>
									   		<span style="color: #999;"  v-if="props.row.is_ok==0">{{$t('monList.no')}}</span>
									   		
									   	</template>
									   </el-table-column>
									   			
									   
									   
									   		
									   <el-table-column width="310"  prop="id" align="center" :label="$t('adminList.operation')">
									   	<template slot-scope="scope">
											 <el-checkbox class="mr-2" v-model="scope.row.is_sel"></el-checkbox>
									   		<el-button-group>
									   			<el-button v-if="!canOpenPdfMerge(scope.row,props.row)" :disabled="layout.loading" :loading="layout.loading" v-auth="'down'+auth_val" @click="printPdf(props.row,scope.row.account_id,3)"  size="mini" plain type="success">{{$t('monList.down')}}</el-button>
												<el-dropdown v-else v-auth="'down'+auth_val" split-button size="mini" type="success" :disabled="layout.loading" @click="printPdf(props.row,scope.row.account_id,3)" @command="handleAccountPdfCommand">
													{{$t('monList.down')}}
													<el-dropdown-menu slot="dropdown">
														<el-dropdown-item :command="{ type: 'mergePdf', row: scope.row, cloudRow: props.row }">合并PDF</el-dropdown-item>
													</el-dropdown-menu>
												</el-dropdown>
												
												
												<el-dropdown v-auth="'other'+auth_val"  :disabled="scope.row.load" @command="againNewOrder">
												  <el-button size="mini" type="primary">
												    {{$t('adminList.operation')}}<i class="el-icon-arrow-down el-icon--right"></i>
												  </el-button>
												  <el-dropdown-menu  slot="dropdown">
													<el-dropdown-item :command="{ type: 'copy', row: scope.row }">{{$t('monList.copyOrder')}}</el-dropdown-item>
													<el-dropdown-item :command="{ type: 'again', pull_mode: 'remote', row: scope.row }">{{$t('monList.againGet')}}</el-dropdown-item>
													<el-dropdown-item :command="{ type: 'again', pull_mode: 'local', row: scope.row }">{{$t('monList.localRebuild')}}</el-dropdown-item>
													<el-dropdown-item v-if="canAgainOdds(scope.row,props.row,2)" :command="{ type: 'againOdds', level: 2, row: scope.row }">{{$t('monList.againOdds')}}</el-dropdown-item>
												    <el-dropdown-item :command="{ type: 'clear', row: scope.row }">{{$t('monList.clear')}}</el-dropdown-item>
												 
												    
												  </el-dropdown-menu>
												</el-dropdown>
									   			
									   			<!-- <el-button :disabled="layout.loading || scope.row.is_ok==1 || scope.row.is_now_mon==1" :loading="layout.loading"  @click="confirmOrder(scope.row.id)"  size="mini" plain type="warning">{{$t('monList.confirmOrder')}}</el-button> -->
									   		</el-button-group>
									   	</template>
									   </el-table-column>
									   
									   
								   </el-table>
							   </template>
						   </el-table-column>
						   <!-- 第二层数据 -->
						   
						   <el-table-column align="center" width="140" prop="user_name" :label="$t('orderList.user')">
						   	<template slot-scope="scope">
						   		<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
						   		
						   	</template>
						   </el-table-column>
						   
						   
						   <el-table-column align="center" width="100" prop="date" :label="$t('orderList.date')">
						   	<template slot-scope="scope">
						   		{{ props.row.date }}
						   	  </template>
						   </el-table-column>
						   
						   
						   <el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
						   	<template slot-scope="scope">
						   		{{ scope.row.cloud_name }}
								
									<i v-if="scope.row.is_rmb==1" class="text_chengse ml-1 iconfont icon-rmb-full"></i>
						   	  </template>
						   </el-table-column>
						   
						   
						   <el-table-column width="120" align="center" label="供应商">
						   	<template slot-scope="scope">
						   		<span>{{$t('status.all')}}</span>
						   	
						   	</template>
						   </el-table-column>
						   
						   
						   <el-table-column width="120" align="center" prop="cloud_name" :label="$t('new1.sup')">
						   	<template slot-scope="scope">
						   		<span>{{$t('status.all')}}</span>
						   	
						   	</template>
						   </el-table-column>
						   
						   
						   
						   <el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
						   	<template slot-scope="scope">
						   		<span>{{$t('status.all')}}</span>
						   		
						   	</template>
						   </el-table-column>
						   
						   <el-table-column width="120" align="center" prop="info" :label="$t('new1.protype')">
						   	<template slot-scope="scope">
						   		<span>{{$t('status.all')}}</span>
						   		
						   	</template>
						   </el-table-column>
						   
						   
						   <el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
						   	<template slot-scope="scope">
						   		<span>{{$t('status.all')}}</span>
						   		
						   	</template>
						   </el-table-column>
						   
						   
						   
						   
						   
						   <el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
						   	
						   
						   </el-table-column>
						   
						   <el-table-column v-if="canUseManualCost()" width="120" align="center" prop="manual_cost_money" label="成本金额">
						   	<template slot-scope="scope">
						   		<span>{{ scope.row.manual_cost_money || '0.00' }}</span>
						   	</template>
						   </el-table-column>
						   
						   
						   
						   
						   <el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
							   
	  
						   </el-table-column>
						   
						   
						   <el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
						   	
						   
						   </el-table-column>
						   
						   <el-table-column  width="100" align="center" prop="odds" :label="$t('orderList.odds')">
						   	
						   
						   </el-table-column>
						   
						   
						   
						   <el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
						   	<template slot-scope="scope">
						   		<span class="text_chengse">{{scope.row.need_money}}</span>
						   	</template>
						   </el-table-column>
						   
						   
						   
						   <el-table-column align="center"  width="120"  prop="is_ok" :label="$t('monList.confirmOrder')">
						   	<template slot-scope="scope">
						   		<span class="text-success"  v-if="props.row.is_ok==1">{{$t('monList.yes')}}</span>
								<span class="text-success"  v-if="props.row.is_ok==2">{{$t('monList.yes2')}}</span>
						   		<span style="color: #999;"  v-if="props.row.is_ok==0">{{$t('monList.no')}}</span>
						   		
						   	</template>
						   </el-table-column>
						   			
						   
						   
						   		
						   <el-table-column width="310"  prop="id" align="center" :label="$t('adminList.operation')">
						   	<template slot-scope="scope">
								
								
						   		<el-button-group>
									<el-button :disabled="layout.loading" :loading="layout.loading"  @click="printPdf(props.row,scope.row.cloud_id,2,1,scope.row)" v-auth="'down'+auth_val"  size="mini" plain >{{$t('monList.downsel')}}</el-button>
									<el-button :disabled="layout.loading" :loading="layout.loading"  @click="openSelectedPdfMergeModel(props.row,scope.row)" v-auth="'down'+auth_val"  size="mini" plain >合并下载选中</el-button>
									
									
						   			<el-button :disabled="layout.loading" :loading="layout.loading"  @click="printPdf(props.row,scope.row.cloud_id,2)" v-auth="'down'+auth_val"  size="mini" plain type="success">{{$t('monList.down')}}</el-button>
									
									
						   			
						   			
						   		</el-button-group>
						   	</template>
						   </el-table-column>
											
							
							
						
				       	
		
				     
				
				       </el-table>
				     </template>
				   </el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				
				
				<el-table-column align="center" width="140" prop="user_name" :label="$t('monList.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="date" :label="$t('monList.date')">
				</el-table-column>
				
				
				<el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						<i v-if="scope.row.is_rmb==1" class="text_chengse ml-1 iconfont icon-rmb-full"></i>
					</template>
				</el-table-column>
				
				<el-table-column width="120" align="center" label="供应商">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
						
						
					</template>
				</el-table-column>
				
				<el-table-column width="120" align="center" prop="cloud_name" :label="$t('new1.sup')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
						
						
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
				<el-table-column width="120" align="center" prop="info" :label="$t('new1.protype')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
				<el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
				
				
			<el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
				
			
			</el-table-column>
			
			<el-table-column v-if="canUseManualCost()" width="120" align="center" prop="manual_cost_money" label="成本金额">
				<template slot-scope="scope">
					<span>{{ scope.row.manual_cost_money || '0.00' }}</span>
				</template>
			</el-table-column>
				
				
				<el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
				</el-table-column>
				
				
				<el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
					
				
				</el-table-column>
				
				
				<el-table-column  width="100" align="center" prop="odds" :label="$t('orderList.odds')">
					
				
				</el-table-column>
				

				
				<el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.need_money}}</span>
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center"  width="120"  prop="is_ok" :label="$t('monList.confirmOrder')">
					<template slot-scope="scope">
						<span class="text-success"  v-if="scope.row.is_ok==1">{{$t('monList.yes')}}</span>
						<span class="text-success"  v-if="scope.row.is_ok==2">{{$t('monList.yes2')}}</span>
						<span style="color: #999;"  v-if="scope.row.is_ok==0">{{$t('monList.no')}}</span>
						
					</template>
				</el-table-column>
			
				
				
		
				<el-table-column width="310"  prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button :disabled="layout.loading" :loading="layout.loading"  @click="printPdf(scope.row)" v-auth="'down'+auth_val" size="mini" plain type="success">{{$t('monList.down')}}</el-button>
							
							<el-button v-if="scope.row.is_ok_agent==0  && !ac_id " :disabled="layout.loading || scope.row.is_ok==1 || scope.row.is_now_mon==1 " :loading="layout.loading" v-auth="'other'+auth_val" @click="confirmOrder(scope.row.id,1)"  size="mini" plain type="warning">{{$t('monList.confirmOrder')}}</el-button>
							
							<el-button v-if="scope.row.is_ok_agent==1  && !ac_id " :disabled="layout.loading || scope.row.is_pay==1 || scope.row.is_now_mon==1 " :loading="layout.loading" v-auth="'other'+auth_val" @click="confirmOrder(scope.row.id,2)"  size="mini" plain type="info">{{$t('monList.confirmPay')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('orderList.editOrder') : $t('orderList.addOrder')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				<el-form-item :label="$t('orderList.OrderType')">
					<el-radio-group v-model="form.type" size="small">
						<el-radio :label="1" border>{{$t('orderList.OrderType1')}}</el-radio>
						<el-radio :disabled="true" :label="2" border>{{$t('orderList.OrderType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud($event, 'form')" :disabled="editIndex > -1" v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item v-if="editIndex <= -1" label="供应商" prop="supplier_id">
					<el-select @change="changeOrderAccountFilter" clearable :disabled="editIndex > -1" v-model="form.supplier_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item v-if="editIndex <= -1" :label="$t('new1.sup')" prop="sup_id">
					<el-select @change="changeOrderAccountFilter" clearable :disabled="editIndex > -1" v-model="form.sup_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item v-loading="layout.loading" v-if="form.cloud_id" :label="$t('model.yunAccount')" prop="account_id">
					<el-select @change="changeAccount" style="width: 85%;"  :disabled="editIndex > -1" v-model="form.account_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
						
						<span>{{ item.name }}</span>
						<el-tag v-if="item.pay_type==2" type="warning" size="mini" class="ml-1">预付费</el-tag>
					</el-option>
					</el-select>
				</el-form-item>
				
			
				
				
			
				<!-- <el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				
				
				
				<el-form-item :label="$t('orderList.product')" prop="product_id">
					<el-select @change="selProduct" v-model="form.product_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item  :label="$t('orderList.logType')">
					<el-radio-group v-model="form.log_type" size="small">
						<el-radio :label="1" border>{{$t('orderList.logType1')}}</el-radio>
						<el-radio :label="2" border>{{$t('orderList.logType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				<el-form-item  :label="$t('orderList.date')" prop="date">
					 <el-date-picker
					      v-model="form.date"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  format="yyyy-MM-dd"
					      type="date"
					      :placeholder="$t('orderList.selDate')">
					    </el-date-picker>
				</el-form-item>
				
				
				<el-form-item v-if="form.log_type==1"  :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" type="number" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item  :label="$t('orderList.addType')">
					<el-radio-group v-model="form.add_type" size="small">
						<el-radio :label="1" border>{{$t('orderList.addType1')}}</el-radio>
						<el-radio :label="2" border>{{$t('orderList.addType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item v-if="form.add_type==1"  :label="form.log_type==1?$t('orderList.money'):$t('orderList.money2')" prop="money">
					<el-input v-model="form.money" type="number" :placeholder="form.log_type==1?$t('orderList.money'):$t('orderList.money2')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item v-if="form.add_type==2" :label="$t('orderList.detail')" >
					<div class="order-detail-row" v-for="(item,index) in form.detail" :key="index">
						<el-input class="order-detail-input" v-model="item.service" type="text" :placeholder="$t('orderList.service')" clearable size="small" ></el-input>
						<el-input class="order-detail-input" v-model="item.money" type="number" :placeholder="form.log_type==1?$t('orderList.money'):$t('orderList.money2')" clearable size="small" ></el-input>
						<el-input class="order-detail-input" v-model="item.use_num" type="number" :placeholder="$t('orderList.use_num')" clearable size="small"></el-input>
						<el-input class="order-detail-input" v-model="item.unit" type="text" :placeholder="$t('orderList.unit')" clearable size="small" ></el-input>
						<el-input v-if="form.log_type==1" class="order-detail-input" v-model="item.odds" type="number" :placeholder="$t('userList.odds')" clearable size="small" ></el-input>
						
						<div class="order-detail-actions">
							<el-button @click="addOrderLog" size="mini" type="success" icon="el-icon-plus" circle></el-button>
							<el-button v-if="form.detail.length>1" @click="delOrderLog(index)" size="mini" type="danger" icon="el-icon-delete" circle></el-button>
						</div>
					</div>
				</el-form-item>
				
				
				
				
				
				
				
				
			
				
				
				
				<el-form-item   v-if="form.add_type==1"  :label="$t('orderList.use_num')" prop="use_num">
					<el-input v-model="form.use_num" type="number" :placeholder="$t('orderList.use_num')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item   v-if="form.add_type==1"  :label="$t('orderList.unit')" prop="unit">
					<el-input v-model="form.unit" type="number" :placeholder="$t('orderList.unit')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item  :label="$t('orderList.order_no')" prop="order_no">
					<el-input v-model="form.order_no" :placeholder="$t('orderList.order_no')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
			
				
				
				<el-form-item :label="$t('orderList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('userList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button  :disabled="layout.loading" :loading="layout.loading"  type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('new1.tousd')"
			:visible.sync="otherModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_other" ref="form_other" :model="other" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item :label="$t('new1.use_usd')" prop="usd">
					<el-input v-model="other.usd" type="usd" :placeholder="$t('new1.use_usd')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				
				<el-form-item :label="$t('monList.mon')"  prop="date">
					 <el-date-picker
					      size="small"
					      v-model="other.date"
					      type="month"
					      align="right"
					      unlink-panels
						  value-format="yyyy-MM-dd"
					      :range-separator="$t('system.to')"
					      :start-placeholder="$t('system.startTime')"
					      :end-placeholder="$t('system.endTime')"
					      >
					    </el-date-picker>
				</el-form-item>

				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud($event, 'other')" :disabled="editIndex > -1" v-model="other.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					<el-option  :label="$t('status.all')" :value="0"></el-option>
						<el-option v-for="item in agentData.hl_cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="供应商" prop="supplier_id">
					<el-select @change="changeAccountFilter('other')" clearable v-model="other.supplier_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('new1.sup')" prop="sup_id">
					<el-select @change="changeAccountFilter('other')" clearable v-model="other.sup_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			
				
		
		
			<el-form-item v-loading="layout.loading" v-if="other.cloud_id!=0" :label="$t('model.yunAccount')" prop="account_id">
				<el-select multiple @change="selHlAccount" style="width: 85%;"   v-model="other.account_id" size="small" filterable :placeholder="$t('system.select')">
				<el-option   :label="$t('status.all')" :value="0"></el-option>
					<el-option  v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
					
						<span>{{ item.name }}</span>
						<el-tag v-if="item.pay_type==2" type="warning" size="mini" class="ml-1">预付费</el-tag>
					</el-option>
				</el-select>
			</el-form-item>
			
			
				
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="otherModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="layout.loading" :loading="layout.loading" @click="submitOther">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		<!-- 补充公云后付费云服务器当月价格 -->
		<el-dialog :close-on-click-modal="false"
			title="补充云服务器价格"
			:visible.sync="pendingServerPriceModel"
			top="5vh"
			:width="layout.is_phone?'90%':'520px'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<el-form style="max-height: 65vh; overflow: auto;" :model="pendingServerPrice" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item label="服务器">
					{{ pendingServerPrice.service }}
				</el-form-item>
				<el-form-item label="销售价">
					<el-input v-model="pendingServerPrice.order_money" type="number" placeholder="请输入当月销售价" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item label="成本金额">
					<el-input v-model="pendingServerPrice.cost_money" type="number" placeholder="请输入当月成本" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('orderList.odds')">
					<el-input v-model="pendingServerPrice.odds" type="number" :placeholder="$t('orderList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="pendingServerPriceModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="layout.loading" :loading="layout.loading" @click="savePendingServerPriceApi">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

		<!-- 数据确定 -->
		<el-dialog :close-on-click-modal="false"
			title="数据确定"
			:visible.sync="billConfirm.model"
			top="5vh"
			:width="layout.is_phone?'95%':'85%'"
			:append-to-body="true"
			custom-class="custom-dialog bill-confirm-dialog">
			<el-form inline size="small">
				<el-form-item label="月份">
					<el-date-picker
						v-model="billConfirm.date"
						type="month"
						value-format="yyyy-MM"
						format="yyyy-MM"
						placeholder="请选择月份"
						@change="loadBillConfirmPreview(true)">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="billConfirm.search_status" style="width: 130px;" @change="billConfirm.page=1">
						<el-option label="全部" value="all"></el-option>
						<el-option label="有变化" value="changed"></el-option>
						<el-option label="无变化" value="no_diff"></el-option>
						<el-option label="未确定" value="unconfirmed"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button :loading="billConfirm.previewLoading" @click="loadBillConfirmPreview">查询</el-button>
					<el-button type="primary" :loading="billConfirm.loading" :disabled="!billConfirm.can_confirm || billConfirm.previewLoading || billConfirm.list.length==0" @click="confirmBillData">确认数据确定</el-button>
				</el-form-item>
				<el-form-item>
					<el-tag type="primary">本次将生成第{{ billConfirm.next_stage }}次数据确定</el-tag>
				</el-form-item>
			</el-form>
			<div class="mb-2">
				<el-tag size="small" type="success">账号数：{{ billConfirm.count }}</el-tag>
				<el-tag size="small" type="danger" class="ml-2">有变化：{{ billConfirmDisplayDiffCount }}</el-tag>
				<el-tag size="small" type="success" class="ml-2">无变化：{{ billConfirmNoDisplayDiffCount }}</el-tag>
				<el-tag size="small" type="info" class="ml-2">未确定：{{ billConfirm.unconfirmed_count }}</el-tag>
				<el-tag size="small" type="warning" class="ml-2">账单金额：{{ billConfirm.summary.order_money }}</el-tag>
				<el-tag size="small" class="ml-2">合计消费：{{ billConfirm.summary.total }}</el-tag>
				<el-tag size="small" type="info" class="ml-2">成本金额：{{ billConfirm.summary.cost_money }}</el-tag>
			</div>
			<div class="bill-confirm-table-wrap">
				<el-table v-loading="billConfirm.previewLoading" :data="billConfirmPagedList" border size="small" style="width: 100%;" :max-height="layout.is_phone?440:680">
					<el-table-column prop="user_name" label="用户" min-width="120"></el-table-column>
					<el-table-column label="账号" min-width="170">
						<template slot-scope="scope">
							<div>{{ scope.row.ac_id }}</div>
							<div class="text-muted" v-if="scope.row.username">{{ scope.row.username }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="cloud_name" label="云服务商" min-width="100"></el-table-column>
					<el-table-column label="供应商" min-width="140">
						<template slot-scope="scope">
							<div>{{ scope.row.provider_supplier_name || '-' }}</div>
							<div class="text-muted" v-if="scope.row.sup_name">{{ scope.row.sup_name }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="order_money" label="账单金额" min-width="100"></el-table-column>
					<el-table-column prop="total" label="合计消费" min-width="100"></el-table-column>
					<el-table-column prop="odds_money" label="折扣金额" min-width="100"></el-table-column>
					<el-table-column prop="cost_money" label="成本金额" min-width="100"></el-table-column>
					<el-table-column prop="need_money" label="待支付" min-width="100"></el-table-column>
					<el-table-column label="变化" min-width="300">
						<template slot-scope="scope">
							<div v-if="confirmStage(scope.row)">
								<el-tag size="mini" :type="hasConfirmDiff(scope.row)?'danger':'success'">对比第{{ confirmStage(scope.row) }}次</el-tag>
								<div v-if="hasConfirmDiff(scope.row)" class="mt-1">
									<div v-for="item in scope.row.confirm_diff.changes" :key="item.key">
										{{ item.name }}：{{ item.old }} -> {{ item.new }}
									</div>
								</div>
								<div v-else class="text-muted mt-1">无变化</div>
								<div v-if="showConfirmPreviousDiff(scope.row)" class="bill-confirm-previous-diff">
									<el-tag size="mini" :type="hasConfirmPreviousDiff(scope.row)?'warning':'success'">
										第{{ confirmPreviousDiff(scope.row).previous_stage }}次 对比 第{{ confirmPreviousDiff(scope.row).stage }}次
									</el-tag>
									<div v-if="hasConfirmPreviousDiff(scope.row)" class="mt-1">
										<div v-for="item in confirmPreviousDiff(scope.row).changes" :key="'previous_'+item.key">
											{{ item.name }}：{{ item.new }} -> {{ item.old }}
										</div>
									</div>
									<div v-else class="text-muted mt-1">与上一次无变化</div>
								</div>
							</div>
							<span v-else class="text-muted">未确定</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer bill-confirm-footer">
				<div class="bill-confirm-footer-left">
					<div class="bill-confirm-pagination" v-if="billConfirmFilteredList.length>0">
						<el-pagination
							background
							:small="layout.is_phone"
							:current-page.sync="billConfirm.page"
							:page-size.sync="billConfirm.limit"
							:page-sizes="[10,20,50,100]"
							:total="billConfirmFilteredList.length"
							@size-change="billConfirm.page=1"
							layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</div>
					<el-button @click="billConfirm.model = false">{{$t('adminList.cancel')}}</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 待定价/快捷补录列表 -->
		<el-dialog :close-on-click-modal="false"
			title="待定价 / 快捷补录"
			:visible.sync="pendingServerPriceListModel"
			top="5vh"
			:width="layout.is_phone?'95%':'90%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<div class="pending-price-toolbar">
				<span>Amazon SUPPORT 月份</span>
				<el-date-picker
					v-model="pendingServerPriceBatch.support_month"
					type="month"
					value-format="yyyy-MM-dd"
					size="small"
					placeholder="选择月份"
					@change="loadPendingServerPriceList">
				</el-date-picker>
				<div class="pending-price-toolbar-actions">
					<el-button size="small" type="primary" :loading="pendingServerPriceBatch.saving" :disabled="pendingServerPriceBatch.loading || pendingServerPriceBatch.list.length==0" @click="savePendingServerPriceAll">保存</el-button>
				</div>
			</div>
			<el-table v-loading="pendingServerPriceBatch.loading" :data="pendingServerPriceBatch.list" border size="small" style="width: 100%;">
				<el-table-column align="center" prop="pending_type_name" label="处理类型" width="160">
					<template slot-scope="scope">{{ scope.row.pending_type_name || '云服务器' }}</template>
				</el-table-column>
				<el-table-column align="center" prop="user_name" :label="$t('monList.user')" width="140"></el-table-column>
				<el-table-column align="center" prop="date" :label="$t('monList.date')" width="100"></el-table-column>
				<el-table-column align="center" prop="cloud_name" :label="$t('accountList.cloudName')" width="120"></el-table-column>
				<el-table-column align="center" prop="ac_id" :label="$t('model.yunAccount')" width="150"></el-table-column>
				<el-table-column align="center" prop="provider_supplier_name" label="供应商" width="120">
					<template slot-scope="scope">{{ scope.row.provider_supplier_name || '-' }}</template>
				</el-table-column>
				<el-table-column align="center" prop="sup_name" :label="$t('new1.sup')" width="120"></el-table-column>
				<el-table-column align="center" prop="server_name" label="项目" width="180">
					<template slot-scope="scope">
						<div>{{ scope.row.server_name }}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="input_order_money" :label="$t('orderList.order_money')" width="150">
					<template slot-scope="scope">
						<el-input v-model="scope.row.input_order_money" type="number" size="mini" :placeholder="scope.row.pending_type=='amazon_support' ? '账单金额' : '销售价'"></el-input>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="input_cost_money" label="成本金额" width="150">
					<template slot-scope="scope">
						<el-input v-if="scope.row.pending_type!='amazon_support'" v-model="scope.row.input_cost_money" type="number" size="mini" placeholder="成本"></el-input>
						<span v-else>{{ scope.row.cost_money || '0.00' }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="input_odds" :label="$t('orderList.odds')" width="120">
					<template slot-scope="scope">
						<el-input v-model="scope.row.input_odds" type="number" size="mini"></el-input>
					</template>
				</el-table-column>
				<el-table-column align="center" :label="$t('adminList.operation')" width="100">
					<template slot-scope="scope">
						<el-button size="mini" plain type="primary" :loading="scope.row.saving" :disabled="pendingServerPriceBatch.loading" @click="savePendingServerPriceRow(scope.row)">保存</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="!pendingServerPriceBatch.loading && pendingServerPriceBatch.list.length==0" class="text-muted text-center py-3">暂无待定价数据</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="pendingServerPriceListModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="pendingServerPriceBatch.loading" @click="loadPendingServerPriceList">刷新</el-button>
			</div>
		</el-dialog>
		
		<!-- 修正折扣 -->
		<el-dialog :close-on-click-modal="false"
			:title="$t('monList.againOdds')"
			:visible.sync="oddsModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_odds" ref="form_other" :model="odds" :label-width="layout.is_phone?'80px':'100px'">
				
				
				<el-form-item :label="$t('monList.nowOdds')" prop="now">
					{{odds.now}}
				</el-form-item>
				<el-form-item :label="$t('orderList.odds')" prop="odds">
					<el-input v-model="odds.odds" type="number" :placeholder="$t('orderList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="oddsModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="layout.loading" :loading="layout.loading" @click="againOddsApi">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		<!-- 重新拉取 -->
		<el-dialog :close-on-click-modal="false"
			:title="$t('monList.againGet')"
			:visible.sync="againModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_again" ref="form_again" :model="again" :label-width="layout.is_phone?'80px':'100px'">

			
				
				<el-form-item :label="$t('monList.mon')"  prop="date">
					 <el-date-picker
					      size="small"
					      v-model="again.date"
					      type="month"
					      align="right"
					      unlink-panels
						  value-format="yyyy-MM-dd"
					      :range-separator="$t('system.to')"
					      :start-placeholder="$t('system.startTime')"
					      :end-placeholder="$t('system.endTime')"
					      >
					    </el-date-picker>
				</el-form-item>
				
				<el-form-item label="操作类型" prop="type">
					<el-radio-group v-model="again.type" size="small">
						<el-radio-button label="again">{{$t('monList.againGet')}}</el-radio-button>
						<el-radio-button label="clear">{{$t('monList.clear')}}</el-radio-button>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="again.type!='clear'" :label="$t('monList.pullMode')" prop="pull_mode">
					<el-radio-group v-model="again.pull_mode" size="small">
						<el-radio-button label="remote">{{$t('monList.remotePull')}}</el-radio-button>
						<el-radio-button label="local">{{$t('monList.localRebuild')}}</el-radio-button>
					</el-radio-group>
				</el-form-item>
				
				
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud($event, 'again')" :disabled="editIndex > -1" v-model="again.cloud_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="供应商" prop="supplier_id">
					<el-select @change="changeAccountFilter('again')" clearable v-model="again.supplier_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('new1.sup')" prop="sup_id">
					<el-select @change="changeAccountFilter('again')" clearable v-model="again.sup_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			
				
		

			
			<el-form-item v-loading="layout.loading" v-if="again.cloud_id!=0" :label="$t('model.yunAccount')" prop="account_id">
				<el-select multiple  style="width: 85%;"   v-model="again.account_id" size="small" filterable :placeholder="$t('system.select')">
					<el-option  v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
					
						<span>{{ item.name }}</span>
						<el-tag v-if="item.pay_type==2" type="warning" size="mini" class="ml-1">预付费</el-tag>
					</el-option>
				</el-select>
			</el-form-item>
			
			
				
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="againModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="again.load" :loading="again.load" @click="againNewOrderModel">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		
		
		<!-- 复制账单 -->
		<el-dialog :close-on-click-modal="false"
			:title="$t('monList.copyOrder')"
			:visible.sync="copyDataModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_copy" ref="form_copy" :model="copyData" :label-width="layout.is_phone?'80px':'100px'">
		
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud($event, 'copy')" :disabled="editIndex > -1" v-model="copyData.cloud_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="供应商" prop="supplier_id">
					<el-select @change="changeAccountFilter('copy')" clearable v-model="copyData.supplier_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('new1.sup')" prop="sup_id">
					<el-select @change="changeAccountFilter('copy')" clearable v-model="copyData.sup_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
	
			
			<el-form-item v-loading="layout.loading" v-if="copyData.cloud_id!=0" :label="$t('model.yunAccount')" prop="aid">
				<el-select filterable  style="width: 85%;"   v-model="copyData.aid" size="small"  :placeholder="$t('system.select')">
					<el-option  v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
					
						<span>{{ item.name }}</span>
						<el-tag v-if="item.pay_type==2" type="warning" size="mini" class="ml-1">预付费</el-tag>
					</el-option>
				</el-select>
			</el-form-item>
			
			
			<el-form-item v-if="copyData.has_live_product==1" :label="$t('monList.addOdds')" prop="product_id">
				<el-input v-model="copyData.addOdds" type="number" :placeholder="$t('monList.addOdds')" clearable size="small" style="width: 85%;">
					<template slot="append">%</template>
				</el-input>
			</el-form-item>

			</el-form>
			
			
			
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="copyDataModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="again.load" :loading="again.load" @click="copyNewOrderModel">{{$t('adminList.confirm')}}</el-button>
			</div>
			</el-dialog>
			
			
			<!-- 成本录入 -->
			<el-dialog :close-on-click-modal="false"
				v-if="canUseManualCost()"
				title="成本录入"
				:visible.sync="manualCostModel"
				top="5vh"
				:width="layout.is_phone?'95%':'90%'"
				:append-to-body="true"
				custom-class="custom-dialog manual-cost-dialog">
				<div class="manual-cost-toolbar mb-2">
					<el-form inline :model="manualCost.search">
						<el-form-item :label="$t('monList.mon')" class="mb-0">
							<el-date-picker
								size="small"
								v-model="manualCost.search.time"
								type="month"
								align="right"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="客户" class="mb-0">
							<el-select size="small" v-model="manualCost.search.name" clearable filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('accountList.ac_id')" class="mb-0">
							<el-input size="small" v-model="manualCost.search.username" clearable></el-input>
						</el-form-item>
						<el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select size="small" v-model="manualCost.search.cloud_id" clearable filterable :placeholder="$t('system.select')">
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="供应商" class="mb-0">
							<el-select v-model="manualCost.search.supplier_id" size="small" clearable filterable :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('new1.sup')" class="mb-0">
							<el-select v-model="manualCost.search.sup_id" size="small" clearable filterable :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="mb-0">
							<el-button type="info" size="small" @click="searchManualCost">搜索</el-button>
							<el-button size="small" @click="resetManualCostSearch">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="manual-cost-summary-row mb-2">
					<div class="manual-cost-summary">
						<div class="manual-cost-summary-item manual-cost-summary-order">
							<span>总账单金额：</span>
							<el-popover
								v-if="hasManualCostOrderTooltip(manualCost.summary)"
								placement="top"
								width="220"
								trigger="hover">
								<div>账单金额：{{ formatManualCostMoney(manualCost.summary.normal_order_money) }}</div>
								<div>预充值账单：{{ formatManualCostMoney(manualCost.summary.prepay_order_money) }}</div>
								<strong slot="reference" class="manual-cost-tooltip-money">{{ manualCost.summary.order_money }}</strong>
							</el-popover>
							<strong v-else>{{ manualCost.summary.order_money }}</strong>
						</div>
						<div class="manual-cost-summary-item manual-cost-summary-total">
							<span>总合计消费：</span>
							<strong>{{ manualCost.summary.total }}</strong>
						</div>
						<div class="manual-cost-summary-item manual-cost-summary-cost">
							<span>总成本：</span>
							<strong>{{ manualCost.summary.manual_cost_money }}</strong>
						</div>
						<div class="manual-cost-summary-item manual-cost-summary-cost">
							<span>供应商成本：</span>
							<strong>{{ manualCost.summary.provider_supplier_manual_cost_money }}</strong>
						</div>
						<div class="manual-cost-summary-item manual-cost-summary-profit">
							<span>总利润：</span>
							<strong>{{ manualCost.summary.profit_money }}</strong>
						</div>
					</div>
					<div class="manual-cost-summary-actions">
						<el-button size="small" type="warning" plain @click="openProviderSupplierCostModel">供应商成本</el-button>
						<el-dropdown size="small" @command="handleManualCostExportCommand">
							<el-button size="small" type="success" icon="el-icon-download" :loading="manualCost.exporting">
								导出Excel<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="normal">导出Excel</el-dropdown-item>
								<el-dropdown-item command="edit">导出编辑</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<el-upload
							class="manual-cost-import-upload"
							name="file"
							action="/admin/data/importManualCostExcel"
							:headers="{token:$store.state.user.token}"
							:show-file-list="false"
							:accept="'.xlsx,.xls'"
							:disabled="manualCost.importing"
							:before-upload="beforeManualCostImport"
							:on-success="handleManualCostImportSuccess"
							:on-error="handleManualCostImportError">
							<el-button size="small" type="primary" plain :loading="manualCost.importing" icon="el-icon-upload2">导入编辑</el-button>
						</el-upload>
						<div v-if="manualCost.page.total==1" class="manual-cost-quick-actions">
							<el-input
								size="small"
								v-model="manualCost.costRatio"
								class="manual-cost-ratio-input"
								placeholder="成本比例">
								<template slot="append">%</template>
							</el-input>
							<el-button size="small" type="primary" plain @click="applySingleManualCostRatio">应用比例</el-button>
							<el-button
								size="small"
								type="warning"
								plain
								@click="resetSingleManualCost">
								成本归零
							</el-button>
						</div>
					</div>
				</div>
				<el-table
					ref="manualCostAccountTable"
					v-loading="manualCost.loading"
					:data="manualCost.list"
					row-key="row_key"
					border
					row-class-name="manual-cost-level-1-row"
					style="width: 100%;"
					:max-height="layout.is_phone?360:480"
					@expand-change="openManualCostProduct">
					<el-table-column type="expand" width="48">
						<template slot-scope="props">
							<el-table
								ref="manualCostProductTable"
								v-loading="props.row.load"
								:data="props.row.data"
								row-key="row_key"
								border
								class="manual-cost-inner-table"
								row-class-name="manual-cost-level-2-row"
								:show-header="false"
								style="width: 100%;"
								@expand-change="openManualCostService">
								<el-table-column type="expand" width="48">
									<template slot-scope="props2">
										<el-table
											v-loading="props2.row.load"
											:data="props2.row.data"
											row-key="row_key"
											border
											class="manual-cost-inner-table"
											row-class-name="manual-cost-level-3-row"
											:show-header="false"
											style="width: 100%;">
											<el-table-column width="48"></el-table-column>
											<el-table-column align="center" width="105" show-overflow-tooltip :label="$t('orderList.user')">
												<template slot-scope="scope">{{ props.row.user_name }}</template>
											</el-table-column>
											<el-table-column align="center" width="90" :label="$t('orderList.date')">
												<template slot-scope="scope">{{ props.row.date }}</template>
											</el-table-column>
											<el-table-column align="center" width="105" show-overflow-tooltip :label="$t('accountList.cloudName')">
												<template slot-scope="scope">{{ props.row.cloud_name }}</template>
											</el-table-column>
											<el-table-column align="center" width="105" show-overflow-tooltip label="供应商">
												<template slot-scope="scope">{{ props.row.provider_supplier_name || '-' }}</template>
											</el-table-column>
											<el-table-column align="center" width="95" show-overflow-tooltip :label="$t('new1.sup')">
												<template slot-scope="scope">{{ props.row.sup_name }}</template>
											</el-table-column>
											<el-table-column align="center" min-width="120" :label="$t('model.yunAccount')">
												<template slot-scope="scope">
													<el-popover
														placement="top-start"
														:title="$t('login.username')"
														width="auto"
														trigger="hover">
														<div>{{ props.row.username }}</div>
														<div v-if="props.row.live_user_name">推拉流用户：{{ props.row.live_user_name }}</div>
														<div slot="reference" class="bill-account-cell">
															<span class="bill-account-name">{{ props.row.ac_id }}</span>
															<el-tag v-if="props.row.pay_type==2" type="warning" size="mini" class="bill-prepay-tag">预付费</el-tag>
														</div>
													</el-popover>
												</template>
											</el-table-column>
											<el-table-column align="center" prop="pro_name" label="产品明细" width="115" show-overflow-tooltip></el-table-column>
											<el-table-column align="center" prop="order_money" label="账单金额" width="110"></el-table-column>
											<el-table-column align="center" prop="total" label="合计消费" width="110"></el-table-column>
											<el-table-column align="center" label="利润" width="120">
												<template slot-scope="scope">
													<span>{{ formatManualCostProfit(scope.row) }}</span>
												</template>
											</el-table-column>
											<el-table-column align="center" label="成本金额" width="110">
												<template slot-scope="scope">
													<el-input
														v-if="scope.row.cost_editable"
														class="manual-cost-money-input manual-cost-money-color"
														v-model="scope.row.manual_cost_money"
														type="text"
														size="mini"
														clearable
														@input="markManualCostDirty(scope.row,2,props2.row,props.row)">
													</el-input>
													<span v-else class="manual-cost-money-text">{{ scope.row.manual_cost_money || '0.00' }}</span>
												</template>
											</el-table-column>
										</el-table>
									</template>
								</el-table-column>
								<el-table-column align="center" width="105" show-overflow-tooltip :label="$t('orderList.user')">
									<template slot-scope="scope">{{ props.row.user_name }}</template>
								</el-table-column>
								<el-table-column align="center" width="90" :label="$t('orderList.date')">
									<template slot-scope="scope">{{ props.row.date }}</template>
								</el-table-column>
								<el-table-column align="center" width="105" show-overflow-tooltip :label="$t('accountList.cloudName')">
									<template slot-scope="scope">{{ props.row.cloud_name }}</template>
								</el-table-column>
								<el-table-column align="center" width="105" show-overflow-tooltip label="供应商">
									<template slot-scope="scope">{{ props.row.provider_supplier_name || '-' }}</template>
								</el-table-column>
								<el-table-column align="center" width="95" show-overflow-tooltip :label="$t('new1.sup')">
									<template slot-scope="scope">{{ props.row.sup_name }}</template>
								</el-table-column>
								<el-table-column align="center" min-width="120" :label="$t('model.yunAccount')">
									<template slot-scope="scope">
										<el-popover
											placement="top-start"
											:title="$t('login.username')"
											width="auto"
											trigger="hover">
											<div>{{ props.row.username }}</div>
											<div v-if="props.row.live_user_name">推拉流用户：{{ props.row.live_user_name }}</div>
											<div slot="reference" class="bill-account-cell">
												<span class="bill-account-name">{{ props.row.ac_id }}</span>
												<el-tag v-if="props.row.pay_type==2" type="warning" size="mini" class="bill-prepay-tag">预付费</el-tag>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="pro_name" :label="$t('orderList.product')" width="115" show-overflow-tooltip></el-table-column>
								<el-table-column align="center" prop="order_money" label="账单金额" width="110"></el-table-column>
								<el-table-column align="center" prop="total" label="合计消费" width="110"></el-table-column>
								<el-table-column align="center" label="利润" width="120">
									<template slot-scope="scope">
										<span>{{ formatManualCostProfit(scope.row) }}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" label="成本金额" width="110">
									<template slot-scope="scope">
										<span class="manual-cost-money-text">{{ scope.row.manual_cost_money || '0.00' }}</span>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="user_name" :label="$t('orderList.user')" width="105" show-overflow-tooltip></el-table-column>
					<el-table-column align="center" prop="date" :label="$t('orderList.date')" width="90"></el-table-column>
					<el-table-column align="center" prop="cloud_name" :label="$t('accountList.cloudName')" width="105" show-overflow-tooltip></el-table-column>
					<el-table-column align="center" prop="provider_supplier_name" label="供应商" width="105" show-overflow-tooltip></el-table-column>
					<el-table-column align="center" prop="sup_name" :label="$t('new1.sup')" width="95" show-overflow-tooltip></el-table-column>
					<el-table-column align="center" prop="ac_id" :label="$t('model.yunAccount')" min-width="120">
						<template slot-scope="scope">
							<el-popover
								placement="top-start"
								:title="$t('login.username')"
								width="auto"
								trigger="hover">
								<div>{{ scope.row.username }}</div>
								<div v-if="scope.row.live_user_name">推拉流用户：{{ scope.row.live_user_name }}</div>
								<div slot="reference" class="bill-account-cell">
									<span class="bill-account-name">{{ scope.row.ac_id }}</span>
									<el-tag v-if="scope.row.pay_type==2" type="warning" size="mini" class="bill-prepay-tag">预付费</el-tag>
								</div>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column align="center" :label="$t('orderList.product')" width="115" show-overflow-tooltip>
						<template slot-scope="scope">{{$t('status.all')}}</template>
					</el-table-column>
					<el-table-column align="center" prop="order_money" label="账单金额" width="110">
						<template slot-scope="scope">
							<el-popover
								v-if="hasManualCostOrderTooltip(scope.row)"
								placement="top"
								width="220"
								trigger="hover">
								<div>账单金额：{{ formatManualCostMoney(scope.row.normal_order_money) }}</div>
								<div>预充值账单：{{ formatManualCostMoney(scope.row.prepay_order_money) }}</div>
								<span slot="reference" class="manual-cost-tooltip-money">{{ scope.row.order_money }}</span>
							</el-popover>
							<span v-else>{{ scope.row.order_money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="total" label="合计消费" width="110"></el-table-column>
					<el-table-column align="center" label="利润" width="120">
						<template slot-scope="scope">
							<span>{{ formatManualCostProfit(scope.row) }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="manual_cost_money" label="成本金额" width="110">
						<template slot-scope="scope">
							<el-input
								v-if="scope.row.account_cost_editable==1"
								class="manual-cost-money-input manual-cost-money-color"
								v-model="scope.row.manual_cost_input"
								type="text"
								size="mini"
								clearable
								@input="markManualCostDirty(scope.row,0,null,scope.row)">
							</el-input>
							<span v-else class="manual-cost-money-text">{{ scope.row.manual_cost_money || '0.00' }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div slot="footer" class="dialog-footer manual-cost-footer">
					<div class="manual-cost-pagination">
						<el-pagination
							:current-page="manualCost.page.current"
							:page-sizes="manualCost.page.sizes"
							:page-size="manualCost.page.size"
							@size-change="handleManualCostSizeChange"
							@current-change="handleManualCostCurrentChange"
							background
							:layout="layout.is_phone ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
							:total="manualCost.page.total">
						</el-pagination>
					</div>
					<div class="manual-cost-footer-actions">
						<el-button @click="manualCostModel = false">{{$t('adminList.cancel')}}</el-button>
						<el-button type="primary" :loading="manualCost.saving" @click="saveManualCostAll">保存</el-button>
					</div>
				</div>
			</el-dialog>

			<!-- 供应商成本 -->
			<el-dialog :close-on-click-modal="false"
				v-if="canUseManualCost()"
				title="供应商成本"
				:visible.sync="providerSupplierCostModel"
				top="8vh"
				:width="layout.is_phone?'95%':'75%'"
				:append-to-body="true"
				custom-class="custom-dialog manual-cost-dialog">
				<div class="manual-cost-toolbar mb-2">
					<el-form inline :model="providerSupplierCost.search">
						<el-form-item :label="$t('monList.mon')" class="mb-0">
							<el-date-picker
								size="small"
								v-model="providerSupplierCost.search.time"
								type="month"
								align="right"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="二级供应商" class="mb-0">
							<el-select v-model="providerSupplierCost.search.supplier_id" size="small" clearable filterable :placeholder="$t('system.select')">
								<el-option v-for="item in secondProviderSuppliers()" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="mb-0">
							<el-button type="info" size="small" @click="reloadProviderSupplierCostList">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="manual-cost-summary-row mb-2">
					<div class="manual-cost-summary">
						<div class="manual-cost-summary-item manual-cost-summary-total">
							<span>合计消费：</span>
							<strong>{{ providerSupplierCost.summary.total }}</strong>
						</div>
						<div class="manual-cost-summary-item manual-cost-summary-cost">
							<span>供应商成本：</span>
							<strong>{{ providerSupplierCost.summary.manual_cost_money }}</strong>
						</div>
					</div>
				</div>
				<el-table
					v-loading="providerSupplierCost.loading"
					:data="providerSupplierCost.list"
					border
					style="width: 100%;"
					:max-height="layout.is_phone?360:520">
					<el-table-column align="center" prop="service" label="产品明细" min-width="180" show-overflow-tooltip></el-table-column>
					<el-table-column align="center" prop="product_names" :label="$t('orderList.product')" min-width="160" show-overflow-tooltip>
						<template slot-scope="scope">{{ scope.row.product_names || scope.row.product_ids || '-' }}</template>
					</el-table-column>
					<el-table-column align="center" prop="order_money" label="账单金额" width="110"></el-table-column>
					<el-table-column align="center" prop="total" label="合计消费" width="110"></el-table-column>
					<el-table-column align="center" prop="use_num" :label="$t('orderList.use_num')" width="110"></el-table-column>
					<el-table-column align="center" prop="unit" :label="$t('orderList.unit')" width="90"></el-table-column>
					<el-table-column align="center" label="供应商成本" width="140">
						<template slot-scope="scope">
							<el-input
								class="manual-cost-money-input manual-cost-money-color"
								v-model="scope.row.manual_cost_money"
								type="text"
								size="mini"
								clearable
								@input="refreshProviderSupplierCostSummary">
							</el-input>
						</template>
					</el-table-column>
					<el-table-column align="center" label="状态" width="90">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.only_saved==1" size="mini" type="info">已保存</el-tag>
							<el-tag v-else-if="scope.row.saved==1" size="mini" type="success">已保存</el-tag>
							<el-tag v-else size="mini">未保存</el-tag>
						</template>
					</el-table-column>
				</el-table>
				<div slot="footer" class="dialog-footer manual-cost-footer">
					<div></div>
					<div class="manual-cost-footer-actions">
						<el-button @click="providerSupplierCostModel = false">{{$t('adminList.cancel')}}</el-button>
						<el-button type="primary" :loading="providerSupplierCost.saving" @click="saveProviderSupplierCostAll">保存</el-button>
					</div>
				</div>
			</el-dialog>
			
			
			
			<!-- 推拉流优惠设置 -->
		<el-dialog :close-on-click-modal="false"
			:title="$t('new1.tlOdds')"
			:visible.sync="tlModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_tl" ref="form_tl" :model="tl" :label-width="layout.is_phone?'80px':'100px'">
		
			
				
				<el-form-item :label="$t('monList.mon')"  prop="date">
					 <el-date-picker
					      size="small"
					      v-model="tl.date"
					      type="month"
					      align="right"
					      unlink-panels
						  value-format="yyyy-MM-dd"
					      :range-separator="$t('system.to')"
					      :start-placeholder="$t('system.startTime')"
					      :end-placeholder="$t('system.endTime')"
					      >
					    </el-date-picker>
				</el-form-item>
				
				
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud($event, 'tl')" :disabled="editIndex > -1" v-model="tl.cloud_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="供应商" prop="supplier_id">
					<el-select @change="changeAccountFilter('tl')" clearable v-model="tl.supplier_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('new1.sup')" prop="sup_id">
					<el-select @change="changeAccountFilter('tl')" clearable v-model="tl.sup_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			
				
		
		
		
			
			<el-form-item v-loading="layout.loading" v-if="tl.cloud_id!=0" :label="$t('model.yunAccount')" prop="account_id">
				<el-select   style="width: 85%;"   v-model="tl.account_id" size="small" filterable :placeholder="$t('system.select')">
					<el-option  v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
					
						<span>{{ item.name }}</span>
						<el-tag v-if="item.pay_type==2" type="warning" size="mini" class="ml-1">预付费</el-tag>
					</el-option>
				</el-select>
			</el-form-item>
			
			
			<el-form-item :label="$t('monList.addOdds')" prop="">
				<el-input v-model="tl.add" type="number" :placeholder="$t('monList.addOdds')" clearable size="small" style="width: 85%;"><template slot="append">%</template></el-input>			 
			</el-form-item>
			<hr>
			<div style="color:red;" class="ml-5 mb-1">{{$t('orderList.ltis')}}</div>
			<hr>
			<div class="mb-2"></div>
			<el-form-item :label="$t('orderList.domestic')" prop="domestic">
				<el-input v-model="tl.domestic" type="number" :placeholder="$t('orderList.domestic')" clearable size="small" style="width: 85%;"><template slot="append">W USD / PB</template></el-input>			 
			</el-form-item>
			
			<el-form-item :label="$t('orderList.overseas')" prop="overseas">
				<el-input v-model="tl.overseas" type="number" :placeholder="$t('orderList.overseas')" clearable size="small" style="width: 85%;"><template slot="append">W USD / PB</template></el-input>
			</el-form-item>

			<el-form-item :label="$t('orderList.lowLatencyDomestic')" prop="low_latency_domestic">
				<el-input v-model="tl.low_latency_domestic" type="number" :placeholder="$t('orderList.lowLatencyDomestic')" clearable size="small" style="width: 85%;"><template slot="append">W USD / PB</template></el-input>			 
			</el-form-item>
			
			<el-form-item :label="$t('orderList.lowLatencyOverseas')" prop="low_latency_overseas">
				<el-input v-model="tl.low_latency_overseas" type="number" :placeholder="$t('orderList.lowLatencyOverseas')" clearable size="small" style="width: 85%;"><template slot="append">W USD / PB</template></el-input>
			</el-form-item>
			
			
				
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="tlModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="tl.load" :loading="tl.load" @click="tlSubModel">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		
		<!-- 导出指定 -->
		<el-dialog :close-on-click-modal="false"
			:title="$t('new1.excelset')"
			:visible.sync="excelModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_excel" ref="form_excel" :model="excel" :label-width="layout.is_phone?'80px':'100px'">
		
				<el-form-item :label="$t('monList.mon')"  prop="date">
					 <el-date-picker
					      size="small"
					      v-model="excel.date"
					      type="month"
					      align="right"
					      unlink-panels
						  value-format="yyyy-MM-dd"
					      :range-separator="$t('system.to')"
					      :start-placeholder="$t('system.startTime')"
					      :end-placeholder="$t('system.endTime')"
					      >
					    </el-date-picker>
				</el-form-item>
				
				<el-form-item label="供应商" prop="supplier_id">
					<el-select @change="changeProviderSupplier" :disabled="editIndex > -1" v-model="excel.supplier_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.provider_supplier" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item  :label="$t('new1.sup')" prop="sup_id">
					<el-select @change="changeSup"  :disabled="editIndex > -1" v-model="excel.sup_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item  v-if="excel.supplier_id || excel.sup_id"  :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud($event, 'excel')" :disabled="editIndex > -1" v-model="excel.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					<el-option  :label="$t('status.all')" :value="0"></el-option>
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			
			
			<el-form-item v-loading="layout.loading" v-if="excel.cloud_id!=0" :label="$t('model.yunAccount')" prop="account_id">
				<el-select multiple @change="selHlAccount2" style="width: 85%;"   v-model="excel.account_id" size="small" filterable :placeholder="$t('system.select')">
				<el-option   :label="$t('status.all')" :value="0"></el-option>
					<el-option  v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
					
						<span>{{ item.name }}</span>
						<el-tag v-if="item.pay_type==2" type="warning" size="mini" class="ml-1">预付费</el-tag>
					</el-option>
				</el-select>
			</el-form-item>
			
			
			
		
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="excelModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="layout.loading" :loading="layout.loading" @click="excelSetSub">{{$t('adminList.confirm')}}</el-button>
			</div>
			
			
			
		</el-dialog>
		
		
		<!-- 查询当前重拉 -->
		<el-dialog :close-on-click-modal="false"
			title="当前重拉"
			:visible.sync="checkAgainModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form v-loading="layout.loading" style="max-height: 65vh; overflow: auto;" :rules="rules_odds" ref="form_other" :model="odds" :label-width="layout.is_phone?'80px':'100px'">
				
				<div >
					<el-table :data="checkAgainData" border>
					    <el-table-column align="center" prop="date" label="拉取月份" width="120"></el-table-column>
					    <el-table-column align="center" prop="cloud_name" label="云服务商" width="120"></el-table-column>
					    <el-table-column align="center" prop="ac_id" label="账号" ></el-table-column>
						<el-table-column align="center" prop="pull_mode_name" :label="$t('monList.pullMode')" width="120">
							<template slot-scope="scope">
								<el-tag size="mini" :type="scope.row.pull_mode === 'local' ? 'success' : 'primary'">{{ scope.row.pull_mode_name }}</el-tag>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="callback_status_name" label="外部回调" width="140">
							<template slot-scope="scope">
								<span v-if="scope.row.pull_mode === 'local'">-</span>
								<el-tag v-else size="mini" :type="scope.row.callback_status === 1 ? 'success' : 'danger'">{{ scope.row.callback_status_name }}</el-tag>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="external_count" label="外部条数" width="110"></el-table-column>
						<el-table-column align="center" prop="external_last_time" label="最后数据时间" width="140"></el-table-column>
						<el-table-column align="center" prop="create_time" label="提交时间" width="180"></el-table-column>
						<el-table-column align="center" prop="cha" label="处理时间" ></el-table-column>
						<el-table-column align="center" prop="cha" label="操作" width="260">
							<template slot-scope="scope">
								<el-button size="mini" plain type="primary" v-if="scope.row.pull_mode === 'remote' && scope.row.callback_status === 0" @click="checkAgainExternalBill(scope.row)">检查</el-button>
								<el-button size="mini" plain type="success" v-if="scope.row.external_check_status === 1" @click="finishAgainExternalBill(scope.row)">直接完成</el-button>
								<el-button size="mini" plain type="warning" @click="cancelORderAgain(scope.row)">取消重拉</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			
				
				
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="checkAgainModel = false">{{$t('adminList.cancel')}}</el-button>
				<!-- <el-button type="primary" :disabled="layout.loading" :loading="layout.loading" @click="againOddsApi">{{$t('adminList.confirm')}}</el-button> -->
			</div>
		</el-dialog>
		
		<el-dialog :close-on-click-modal="false"
			title="合并账号PDF"
			:visible.sync="pdfMergeModel"
			top="8vh"
			:width="layout.is_phone?'92%':(pdfMerge.mode==='selected'?'760px':'560px')"
			:append-to-body="true"
			custom-class="custom-dialog">
			<el-form :model="pdfMerge" :label-width="layout.is_phone?'90px':'110px'">
				<el-form-item v-if="pdfMerge.mode==='single'" label="主显示账号">
					<el-input :value="pdfMerge.target_label" disabled size="small"></el-input>
				</el-form-item>
				<el-form-item v-if="pdfMerge.mode==='single'" label="合并账号">
					<el-select v-model="pdfMerge.source_account_ids" multiple filterable collapse-tags size="small" style="width:100%;" :loading="pdfMerge.loading" placeholder="请选择要合并进主账号的账号">
						<el-option
							v-for="item in pdfMerge.accounts"
							:key="item.account_id"
							:label="pdfMergeAccountLabel(item)"
							:value="item.account_id">
						</el-option>
					</el-select>
				</el-form-item>
				<template v-if="pdfMerge.mode==='selected'">
					<el-form-item label="导出账号">
						<div class="pdf-merge-selected">
							<el-tag v-for="item in pdfMerge.selected_accounts" :key="item.account_id" size="mini" class="mr-1 mb-1" :type="item.pay_type==2?'warning':''">
								{{ pdfMergeAccountLabel(item) }}<span v-if="item.pay_type==2">（预付费）</span>
							</el-tag>
						</div>
					</el-form-item>
					<el-form-item label="合并规则">
						<div class="pdf-merge-rule-box">
							<div v-for="(rule,index) in pdfMerge.rules" :key="'pdf-merge-rule-'+index" class="pdf-merge-rule-row">
								<el-select v-model="rule.source_account_id" filterable size="small" placeholder="来源账号" class="pdf-merge-rule-select">
									<el-option
										v-for="item in pdfMerge.selected_accounts"
										:key="'source-'+index+'-'+item.account_id"
										:label="pdfMergeAccountLabel(item)"
										:value="item.account_id"
										:disabled="item.pay_type==2 || isPdfMergeSourceDisabled(item.account_id,index)">
									</el-option>
								</el-select>
								<span class="pdf-merge-rule-arrow">合并到</span>
								<el-select v-model="rule.target_account_id" filterable size="small" placeholder="显示账号" class="pdf-merge-rule-select">
									<el-option
										v-for="item in pdfMerge.selected_accounts"
										:key="'target-'+index+'-'+item.account_id"
										:label="pdfMergeAccountLabel(item)"
										:value="item.account_id"
										:disabled="item.pay_type==2 || Number(item.account_id)===Number(rule.source_account_id)">
									</el-option>
								</el-select>
								<el-button size="mini" type="danger" plain @click="removePdfMergeRule(index)">删除</el-button>
							</div>
							<el-button size="mini" type="primary" plain @click="addPdfMergeRule">添加规则</el-button>
						</div>
					</el-form-item>
				</template>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="pdfMergeModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" :disabled="layout.loading || !canSubmitPdfMerge()" :loading="layout.loading" @click="submitPdfMerge">导出PDF</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				checkAgainModel:false,
				checkAgainData:[],
				pdfMergeModel:false,
				pdfMerge:{
					mode:'single',
					row:{},
					cloudRow:{},
					selectedCloudRow:{},
					selected_cloud_id:0,
					target_account_id:0,
					target_label:'',
					source_account_ids:[],
					selected_accounts:[],
					rules:[],
					accounts:[],
					loading:false
				},
				billConfirm:{
					model:false,
					loading:false,
					previewLoading:false,
					date:'',
					search_status:'all',
					mon:'',
					stage:0,
					next_stage:1,
					can_confirm:1,
					count:0,
					diff_count:0,
					changed_count:0,
					no_diff_count:0,
					unconfirmed_count:0,
					has_diff:false,
					list:[],
					page:1,
					limit:20,
					summary:{
						order_money:'0.00',
						total:'0.00',
						cost_money:'0.00',
						need_money:'0.00',
						odds_money:'0.00'
					}
				},
				manualCostModel:false,
				providerSupplierCostModel:false,
				manualCost:{
					loading:false,
					saving:false,
					exporting:false,
					importing:false,
					list:[],
					autoExpand:false,
					pendingCosts:{},
					costRatio:'',
					summary:{
						order_money:'0.00',
						normal_order_money:'0.00',
						prepay_order_money:'0.00',
						total:'0.00',
						account_manual_cost_money:'0.00',
						provider_supplier_manual_cost_money:'0.00',
						manual_cost_money:'0.00',
						profit_money:'0.00'
					},
					page:{
						current:1,
						size:10,
						sizes:[10,20,50,100],
						total:0
					},
					search:{
						time:'',
						name:'',
						username:'',
						cloud_id:'',
						supplier_id:'',
						sup_id:''
					}
				},
				providerSupplierCost:{
					loading:false,
					saving:false,
					list:[],
					summary:{
						total:'0.00',
						manual_cost_money:'0.00'
					},
					search:{
						time:'',
						supplier_id:''
					}
				},
				createModel: false,
				otherModel:false,
				oddsModel:false,
				pendingServerPriceModel:false,
				pendingServerPriceListModel:false,
				againModel:false,
				tlModel:false,
				editIndex: -1,
				ac_id:'',
				
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					cloud_id:-1,
					supplier_id:-1,
					sup_id:-1,
					time:[],
				},
				total:{
					order:0,
					total:0
				},
				auth_val: 'Order',

				preUrl: "data/monList", //列表地址
				delAllUrl: "data/delAccountApplyAll", //批量删除地址
				delUrl: "data/delAccountApply", //删除單条地址
				addUrl: "data/addOrder", //添加/修改地址
				editStatusUrl:"data/editStatusAccountApply",//修改狀態地址
				agentData:[],
				tableData: [],
				account:[],
				odds:{
					row:{},
					now:'',
					odds:100,
					level:3,
					service:'',
					account_id:0,
					cloud_id:0,
					product_id:0,
					date:''
				},
				pendingServerPrice:{
					row:{},
					service:'',
					order_money:'',
					cost_money:'',
					odds:100
				},
				pendingServerPriceBatch:{
					row:{},
					loading:false,
					saving:false,
					support_month:'',
					list:[]
				},
				copyData:{
					row:{},
					aid:'',
					product_id:0,
					copy_type:'product',
					has_live_product:0,
					addOdds:0,
					cloud_id:'',
					supplier_id:'',
					sup_id:'',
				},
				copyDataModel:false,
				other:{
					cloud_id:0,
					account_id:[0],
					date:'',
					usd:'',
					supplier_id:'',
					sup_id:''
				},
				again:{
					cloud_id:'',
					account_id:[],
					date:'',
					load:false,
					pull_mode:'remote',
					type:'again',
					supplier_id:'',
					sup_id:''
				},
				excelModel:false,
				excel:{
					sel:1,
					type:'set',//1按子供应商，2按平台
					cloud_id:0,
					account_id:[0],
					date:'',
					load:false,
					supplier_id:'',
					sup_id:''
				},
				tl:{
					cloud_id:'',
					account_id:'',
					date:'',
					load:false,
					overseas:1,
					domestic:1,
					low_latency_domestic:1,
					low_latency_overseas:1,
					add:0,
					supplier_id:'',
					sup_id:''
				},
				form: {},
				rules_again:{
					date: [{
						required: true,
						message: this.$t('orderList.selDate'),
						trigger: 'blur',
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur'
					}],
				},
				rules_excel:{
					date: [{
						required: true,
						message: this.$t('orderList.selDate'),
						trigger: 'blur',
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur'
					}],
				},
				rules_tl:{
					date: [{
						required: true,
						message: this.$t('orderList.selDate'),
						trigger: 'blur',
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur'
					}],
					domestic: [{
						required: true,
						message: this.$t('orderList.inpDomestic'),
						trigger: 'blur'
					}],
					overseas: [{
						required: true,
						message: this.$t('orderList.inpOverseas'),
						trigger: 'blur'
					}],
					low_latency_domestic: [{
						required: true,
						message: this.$t('orderList.inpLowLatencyDomestic'),
						trigger: 'blur'
					}],
					low_latency_overseas: [{
						required: true,
						message: this.$t('orderList.inpLowLatencyOverseas'),
						trigger: 'blur'
					}],
				},
				
				rules_copy:{

					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					aid: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur'
					}],
				},
				rules_odds:{
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}]
				},
				rules_other:{
					date: [{
						required: true,
						message: this.$t('new1.seldate'),
						trigger: 'blur',
					}],
					usd: [{
						required: true,
						message: this.$t('new1.inpusd'),
						trigger: 'blur',
					}],
				},
				rules: {
					date: [{
						required: true,
						message: this.$t('orderList.selDate'),
						trigger: 'blur',
					}],
					money: [{
						required: true,
						message: this.$t('orderList.inpMoney'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur'
					}],
					product_id: [{
						required: true,
						message: this.$t('orderList.selProduct'),
						trigger: 'blur'
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
				},
				
				rule_list: [],
				check_img_list:[],
				detailTemplate: { service: '', money: '', use_num: '', unit: '', odds: '' },
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			billConfirmFilteredList(){
				let list = Array.isArray(this.billConfirm.list) ? this.billConfirm.list : []
				let status = this.billConfirm.search_status || 'all'
				if(status==='changed'){
					return list.filter(item => this.hasBillConfirmDisplayDiff(item))
				}
				if(status==='no_diff'){
					return list.filter(item => item.confirm_diff && Number(item.confirm_diff.has_confirm || 0)===1 && !this.hasBillConfirmDisplayDiff(item))
				}
				if(status==='unconfirmed'){
					return list.filter(item => item.confirm_diff && Number(item.confirm_diff.has_confirm || 0)!==1)
				}
				return list
			},
			billConfirmDisplayDiffCount(){
				let list = Array.isArray(this.billConfirm.list) ? this.billConfirm.list : []
				return list.filter(item => this.hasBillConfirmDisplayDiff(item)).length
			},
			billConfirmNoDisplayDiffCount(){
				let list = Array.isArray(this.billConfirm.list) ? this.billConfirm.list : []
				return list.filter(item => item.confirm_diff && Number(item.confirm_diff.has_confirm || 0)===1 && !this.hasBillConfirmDisplayDiff(item)).length
			},
			billConfirmPagedList(){
				let list = this.billConfirmFilteredList
				let page = Number(this.billConfirm.page || 1)
				let limit = Number(this.billConfirm.limit || 20)
				if(page < 1){
					page = 1
				}
				if(limit < 1){
					limit = 20
				}
				let maxPage = Math.max(1, Math.ceil(list.length / limit))
				if(page > maxPage){
					page = maxPage
				}
				let start = (page - 1) * limit
				return list.slice(start, start + limit)
			},
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('account');
		},
		methods: {
			canUseManualCost(){
				return this.layout && this.layout.user && this.layout.user.type==1
			},
			canExportBillExcel(){
				let type = this.layout && this.layout.user ? Number(this.layout.user.type) : 0
				return type===1 || type===2
			},
			currentBillConfirmDate(){
				if(typeof this.from.time === 'string' && this.from.time){
					return this.from.time
				}
				return this.getManualCostDefaultMonth()
			},
			loadBillConfirmStatus(){
				if(!this.canUseManualCost()){
					return
				}
				this.axios.post('/admin/data/billConfirmStatus', {
					date:this.currentBillConfirmDate()
				}, {
					token:true
				}).then(res => {
					let info = res.data && res.data.data && res.data.data.list ? res.data.data.list : {}
					this.billConfirm.mon = info.mon || ''
					this.billConfirm.stage = Number(info.stage || 0)
					this.billConfirm.can_confirm = Number(info.can_confirm || 0)
					this.billConfirm.next_stage = this.billConfirm.stage + 1
					this.billConfirm.diff_count = Number(info.diff_count || 0)
					this.billConfirm.changed_count = Number(info.changed_count || 0)
					this.billConfirm.no_diff_count = Number(info.no_diff_count || 0)
					this.billConfirm.unconfirmed_count = Number(info.unconfirmed_count || 0)
					this.billConfirm.has_diff = this.billConfirm.diff_count > 0
				})
			},
			resetBillConfirmPreview(){
				this.billConfirm.list = []
				this.billConfirm.count = 0
				this.billConfirm.diff_count = 0
				this.billConfirm.changed_count = 0
				this.billConfirm.no_diff_count = 0
				this.billConfirm.unconfirmed_count = 0
				this.billConfirm.page = 1
				this.billConfirm.summary = {
					order_money:'0.00',
					total:'0.00',
					cost_money:'0.00',
					need_money:'0.00',
					odds_money:'0.00'
				}
			},
			openBillConfirmModel(){
				if(!this.canUseManualCost()){
					return
				}
				this.billConfirm.model = true
				this.billConfirm.date = this.currentBillConfirmDate().substr(0,7)
				this.billConfirm.search_status = 'all'
				this.resetBillConfirmPreview()
				this.loadBillConfirmPreview(true)
			},
			loadBillConfirmPreview(autoStatus){
				if(!this.billConfirm.date){
					this.resetBillConfirmPreview()
					return
				}
				this.billConfirm.page = 1
				this.billConfirm.previewLoading = true
				this.axios.post('/admin/data/billConfirmPreview', {
					date:this.billConfirm.date
				}, {
					token:true
				}).then(res => {
					let info = res.data && res.data.data && res.data.data.list ? res.data.data.list : {}
					this.billConfirm.mon = info.mon || this.billConfirm.date
					this.billConfirm.stage = Number(info.stage || 0)
					this.billConfirm.next_stage = Number(info.next_stage || 0)
					this.billConfirm.can_confirm = Number(info.can_confirm || 0)
					this.billConfirm.count = Number(info.count || 0)
					this.billConfirm.diff_count = Number(info.diff_count || 0)
					this.billConfirm.changed_count = Number(info.changed_count || 0)
					this.billConfirm.no_diff_count = Number(info.no_diff_count || 0)
					this.billConfirm.unconfirmed_count = Number(info.unconfirmed_count || 0)
					this.billConfirm.summary = info.summary || {
						order_money:'0.00',
						total:'0.00',
						cost_money:'0.00',
						need_money:'0.00',
						odds_money:'0.00'
					}
					this.billConfirm.list = Array.isArray(info.list) ? info.list : []
					this.billConfirm.has_diff = this.billConfirm.diff_count > 0
					if(autoStatus){
						this.billConfirm.search_status = this.billConfirmDisplayDiffCount > 0 ? 'changed' : 'all'
					}
					this.billConfirm.previewLoading = false
				}).catch(() => {
					this.billConfirm.previewLoading = false
				})
			},
			confirmBillData(){
				if(!this.canUseManualCost() || this.billConfirm.loading){
					return
				}
				let date = this.billConfirm.date || this.getManualCostDefaultMonth().substr(0,7)
				let nextStage = Number(this.billConfirm.next_stage || 0)
				this.billConfirm.loading = true
				this.axios.post('/admin/data/confirmBillData', {
					date
				}, {
					token:true
				}).then(res => {
					let info = res.data && res.data.data && res.data.data.list ? res.data.data.list : {}
					this.$message.success(`第${info.stage || nextStage}次数据确定成功，共${info.count || 0}个账号`)
					this.billConfirm.loading = false
					this.loadBillConfirmPreview(true)
					this.loadBillConfirmStatus()
					this.getList()
				}).catch(() => {
					this.billConfirm.loading = false
				})
			},
			confirmStage(row){
				return row && row.confirm_diff ? Number(row.confirm_diff.stage || 0) : 0
			},
			confirmDate(row){
				return row && row.confirm_diff ? (row.confirm_diff.date || '') : ''
			},
			hasConfirmDiff(row){
				return row && row.confirm_diff && Number(row.confirm_diff.is_diff || 0) === 1
			},
			confirmPreviousDiff(row){
				if(!row || !row.confirm_diff || !row.confirm_diff.previous_diff){
					return null
				}
				return row.confirm_diff.previous_diff
			},
			showConfirmPreviousDiff(row){
				let diff = this.confirmPreviousDiff(row)
				return !!(diff && Number(diff.has_previous || 0) === 1)
			},
			hasConfirmPreviousDiff(row){
				let diff = this.confirmPreviousDiff(row)
				return !!(diff && Number(diff.is_diff || 0) === 1)
			},
			hasBillConfirmDisplayDiff(row){
				return this.hasConfirmDiff(row) || this.hasConfirmPreviousDiff(row)
			},
			confirmValue(row,key){
				if(!row || !row.confirm_diff || !row.confirm_diff.data){
					return '0.00'
				}
				return row.confirm_diff.data[key] || '0.00'
			},
			confirmHistoryRows(row,key){
				if(!row || !row.confirm_diff){
					return []
				}
				let history = Array.isArray(row.confirm_diff.history) ? row.confirm_diff.history : []
				if(history.length===0 && row.confirm_diff.data && this.confirmStage(row)){
					history = [{
						stage: this.confirmStage(row),
						date: this.confirmDate(row),
						data: row.confirm_diff.data
					}]
				}
				return history.map(item => {
					let data = item && item.data ? item.data : {}
					return {
						stage: Number(item.stage || 0),
						date: item.date || '',
						value: data[key] || '0.00'
					}
				}).filter(item => item.stage>0)
			},
			confirmChange(row,key){
				if(!row || !row.confirm_diff || !Array.isArray(row.confirm_diff.changes)){
					return null
				}
				return row.confirm_diff.changes.find(item => item.key === key) || null
			},
			confirmFieldChanged(row,key){
				return !!this.confirmChange(row,key)
			},
			confirmDiffValue(row,key){
				let change = this.confirmChange(row,key)
				return change ? change.diff : '0.00'
			},
			secondProviderSuppliers(){
				let list = this.agentData && this.agentData.provider_supplier ? this.agentData.provider_supplier : []
				return list.filter(item => Number(item.type || 1) === 2)
			},
			isSecondProviderSupplier(id){
				return this.secondProviderSuppliers().some(item => Number(item.id) === Number(id))
			},
			openProviderSupplierCostModel(){
				if(!this.canUseManualCost()){
					return
				}
				let supplierId = this.manualCost.search && this.manualCost.search.supplier_id ? this.manualCost.search.supplier_id : ''
				if(!this.isSecondProviderSupplier(supplierId)){
					let list = this.secondProviderSuppliers()
					supplierId = list.length===1 ? list[0].id : ''
				}
				this.providerSupplierCost.search = {
					time:(this.manualCost.search && this.manualCost.search.time) || this.getManualCostDefaultMonth(),
					supplier_id:supplierId
				}
				this.providerSupplierCostModel = true
				this.providerSupplierCost.list = []
				this.providerSupplierCost.summary = {
					total:'0.00',
					manual_cost_money:'0.00'
				}
				if(supplierId){
					this.reloadProviderSupplierCostList()
				}
			},
			reloadProviderSupplierCostList(){
				if(!this.providerSupplierCost.search.supplier_id){
					this.$message({
						message:'请选择二级供应商',
						type:'warning'
					})
					return
				}
				this.providerSupplierCost.loading = true
				this.axios.post('/admin/data/providerSupplierManualCostList', {
					date:this.providerSupplierCost.search.time,
					supplier_id:this.providerSupplierCost.search.supplier_id
				}, {
					token: true,
				}).then(res => {
					let data = res.data.data.list || {}
					this.providerSupplierCost.list = data.list || []
					let summary = data.summary || {}
					this.providerSupplierCost.summary = {
						total:this.formatManualCostMoney(summary.total),
						manual_cost_money:this.formatManualCostMoney(summary.manual_cost_money)
					}
					this.providerSupplierCost.loading = false
				}).catch(err => {
					this.providerSupplierCost.loading = false
					console.log(err)
				})
			},
			refreshProviderSupplierCostSummary(){
				let total = this.providerSupplierCost.list.reduce((sum, item) => {
					return sum + Number(item.manual_cost_money || 0)
				}, 0)
				this.providerSupplierCost.summary.manual_cost_money = this.formatManualCostMoney(total)
			},
			saveProviderSupplierCostAll(){
				if(!this.providerSupplierCost.search.supplier_id){
					this.$message({
						message:'请选择二级供应商',
						type:'warning'
					})
					return
				}
				if(this.providerSupplierCost.list.length===0){
					this.$message({
						message:'暂无可保存的供应商成本',
						type:'info'
					})
					return
				}
				this.providerSupplierCost.saving = true
				this.axios.post('/admin/data/saveProviderSupplierManualCost', {
					date:this.providerSupplierCost.search.time,
					supplier_id:this.providerSupplierCost.search.supplier_id,
					items:this.providerSupplierCost.list.map(item => {
						return {
							service:item.service,
							product_ids:item.product_ids || '',
							money:item.manual_cost_money || 0
						}
					})
				}, {
					token: true,
				}).then(res => {
					this.providerSupplierCost.saving = false
					if(res.data.code==1){
						this.$message({
							message:'保存成功',
							type:'success'
						})
						this.reloadProviderSupplierCostList()
						this.reloadManualCostList()
						this.getList()
					}
				}).catch(err => {
					this.providerSupplierCost.saving = false
					console.log(err)
				})
			},
			selMore(type){
				if(type=='huan'){
					this.openOtherModel()
				}
				if(type=='again'){
					this.openAgainModel()
				}
				
				if(type=='tl'){
					this.opentlModel()
					//this.tlOddsApi()
				}
			},
			opentlModel(){
				this.tl.supplier_id = ''
				this.tl.sup_id = ''
				this.tl.account_id = ''
				this.account = []
				this.tlModel = true;
				this.refreshDialogAccountList('tl')
			},
			
			checkAgain(){
				this.checkAgainModel = true;
				this.checkAgainList()
			},
			getManualCostDefaultMonth(){
				let date = new Date()
				date.setDate(1)
				date.setMonth(date.getMonth() - 1)
				let year = date.getFullYear()
				let month = String(date.getMonth() + 1).padStart(2, '0')
				return `${year}-${month}-01`
			},
			getManualCostInitialMonth(){
				if(typeof this.from.time === 'string' && this.from.time){
					return this.from.time
				}
				return this.getManualCostDefaultMonth()
			},
			initManualCostSearch(){
				this.manualCost.search = {
					time:this.getManualCostInitialMonth(),
					name:this.from.name || '',
					username:this.from.username || '',
					cloud_id:this.from.cloud_id && this.from.cloud_id!=-1 ? this.from.cloud_id : '',
					supplier_id:this.from.supplier_id && this.from.supplier_id!=-1 ? this.from.supplier_id : '',
					sup_id:this.from.sup_id && this.from.sup_id!=-1 ? this.from.sup_id : ''
				}
			},
			openManualCostModel(){
				if(!this.canUseManualCost()){
					return
				}
				this.manualCostModel = true
				this.initManualCostSearch()
				this.manualCost.page.current = 1
				this.manualCost.autoExpand = !!this.manualCost.search.username
				this.reloadManualCostList()
			},
			searchManualCost(){
				this.manualCost.page.current = 1
				this.manualCost.autoExpand = !!this.manualCost.search.username
				this.reloadManualCostList()
			},
			resetManualCostSearch(){
				this.manualCost.search = {
					time:this.getManualCostDefaultMonth(),
					name:'',
					username:'',
					cloud_id:'',
					supplier_id:'',
					sup_id:''
				}
				this.manualCost.page.current = 1
				this.manualCost.autoExpand = false
				this.reloadManualCostList()
			},
			reloadManualCostList(){
				this.manualCost.loading = true
				this.manualCost.pendingCosts = {}
				this.axios.post('/admin/data/manualCostList', {
					page:this.manualCost.page.current,
					limit:this.manualCost.page.size,
					search:this.manualCost.search
				}, {
					token: true,
				}).then(res => {
					let data = res.data.data.list || {}
					let list = Array.isArray(data) ? data : (data.list || [])
					list.forEach(item => {
						if(item.manual_cost_input===undefined || item.manual_cost_input===null){
							item.manual_cost_input = item.account_manual_cost_money || item.manual_cost_money || '0.00'
						}
					})
					this.manualCost.list = list
					this.manualCost.page.total = Array.isArray(data) ? list.length : (data.total || 0)
					let summary = Array.isArray(data) ? {} : (data.summary || {})
					this.manualCost.summary = {
						order_money:this.formatManualCostMoney(summary.order_money),
						normal_order_money:this.formatManualCostMoney(summary.normal_order_money),
						prepay_order_money:this.formatManualCostMoney(summary.prepay_order_money),
						total:this.formatManualCostMoney(summary.total),
						account_manual_cost_money:this.formatManualCostMoney(summary.account_manual_cost_money),
						provider_supplier_manual_cost_money:this.formatManualCostMoney(summary.provider_supplier_manual_cost_money),
						manual_cost_money:this.formatManualCostMoney(summary.manual_cost_money),
						profit_money:this.formatManualCostMoney(summary.profit_money)
					}
					this.manualCost.loading = false
					if(this.manualCost.autoExpand){
						this.$nextTick(() => {
							this.expandManualCostAll()
						})
					}
				}).catch(err => {
					this.manualCost.loading = false
					this.manualCost.summary = {
						order_money:'0.00',
						normal_order_money:'0.00',
						prepay_order_money:'0.00',
						total:'0.00',
						account_manual_cost_money:'0.00',
						provider_supplier_manual_cost_money:'0.00',
						manual_cost_money:'0.00',
						profit_money:'0.00'
					}
					console.log(err)
				})
			},
			handleManualCostSizeChange(size){
				this.manualCost.page.size = size
				this.manualCost.page.current = 1
				this.reloadManualCostList()
			},
			handleManualCostCurrentChange(page){
				this.manualCost.page.current = page
				this.reloadManualCostList()
			},
			expandManualCostAll(){
				if(this.$refs.manualCostAccountTable){
					this.manualCost.list.forEach(row => {
						this.$refs.manualCostAccountTable.toggleRowExpansion(row, true)
						this.openManualCostProduct(row, true)
					})
				}
			},
			isManualCostExpanded(row, expanded){
				if(Array.isArray(expanded)){
					return expanded.indexOf(row) !== -1
				}
				return expanded !== false
			},
			openManualCostProduct(row, expanded){
				if(!this.isManualCostExpanded(row, expanded)){
					return
				}
				if(row.load){
					return Promise.resolve(row.data || [])
				}
				if(row.manual_cost_loaded && !row.manual_cost_error){
					this.$nextTick(() => {
						this.expandManualCostProducts(row)
					})
					return Promise.resolve(row.data)
				}
				this.$set(row, 'manual_cost_error', false)
				row.load = true
				return this.axios.post('/admin/data/manualCostDetail', {
					type:1,
					uid:row.uid,
					date:row.date,
					cloud_id:row.cloud_id,
					account_id:row.account_id
				}, {
					token: true,
				}).then(res => {
					this.$set(row, 'data', res.data.data.list || [])
					this.$set(row, 'manual_cost_loaded', true)
					this.$set(row, 'manual_cost_error', false)
					row.load = false
					this.$nextTick(() => {
						this.expandManualCostProducts(row)
					})
					return row.data
				}).catch(err => {
					row.load = false
					this.$set(row, 'manual_cost_loaded', false)
					this.$set(row, 'manual_cost_error', true)
					console.log(err)
					return []
				})
			},
			expandManualCostProducts(accountRow){
				if(!this.$refs.manualCostProductTable){
					return
				}
				let tables = Array.isArray(this.$refs.manualCostProductTable) ? this.$refs.manualCostProductTable : [this.$refs.manualCostProductTable]
				accountRow.data.forEach(row => {
					tables.forEach(table => {
						if(table && table.data && table.data.indexOf(row) !== -1 && row.has_detail==1){
							table.toggleRowExpansion(row, true)
							this.openManualCostService(row, true)
						}
					})
				})
			},
			openManualCostService(row, expanded){
				if(!this.isManualCostExpanded(row, expanded) || row.has_detail==0){
					return
				}
				if(row.load){
					return Promise.resolve(row.data || [])
				}
				if(row.manual_cost_loaded && !row.manual_cost_error){
					return Promise.resolve(row.data)
				}
				this.$set(row, 'manual_cost_error', false)
				row.load = true
				return this.axios.post('/admin/data/manualCostDetail', {
					type:2,
					uid:row.uid,
					date:row.date,
					cloud_id:row.cloud_id,
					account_id:row.account_id,
					product_id:row.product_id
				}, {
					token: true,
				}).then(res => {
					this.$set(row, 'data', res.data.data.list || [])
					this.$set(row, 'manual_cost_loaded', true)
					this.$set(row, 'manual_cost_error', false)
					row.load = false
					return row.data
				}).catch(err => {
					row.load = false
					this.$set(row, 'manual_cost_loaded', false)
					this.$set(row, 'manual_cost_error', true)
					console.log(err)
					return []
				})
			},
			formatManualCostMoney(value){
				return Number(value || 0).toFixed(2)
			},
			hasManualCostOrderTooltip(row){
				return Number(row && row.prepay_order_money || 0) !== 0
			},
			formatManualCostProfit(row){
				return this.formatManualCostMoney(Number(row.total || 0) - Number(row.manual_cost_money || row.manual_cost_input || 0))
			},
			handleManualCostExportCommand(command){
				if(command==='edit'){
					this.exportManualCostEditExcel()
					return
				}
				this.exportManualCostExcel()
			},
			downloadManualCostExcelUrl(url){
				if(url){
					let a = document.createElement('a')
					a.href = url
					a.target = '_blank'
					a.click()
				}
			},
			exportManualCostExcel(){
				this.manualCost.exporting = true
				this.axios.post('/admin/data/manualCostExcel', {
					search:this.manualCost.search
				}, {
					token: true,
				}).then(res => {
					this.manualCost.exporting = false
					let url = res.data && res.data.data && res.data.data.list ? res.data.data.list : ''
					this.downloadManualCostExcelUrl(url)
				}).catch(err => {
					this.manualCost.exporting = false
					console.log(err)
				})
			},
			exportManualCostEditExcel(){
				this.manualCost.exporting = true
				this.axios.post('/admin/data/manualCostEditExcel', {
					search:this.manualCost.search
				}, {
					token: true,
				}).then(res => {
					this.manualCost.exporting = false
					let url = res.data && res.data.data && res.data.data.list ? res.data.data.list : ''
					this.downloadManualCostExcelUrl(url)
				}).catch(err => {
					this.manualCost.exporting = false
					console.log(err)
				})
			},
			beforeManualCostImport(file){
				let name = file.name || ''
				let isExcel = /\.(xlsx|xls)$/i.test(name)
				if(!isExcel){
					this.$message.error('请上传Excel文件')
					return false
				}
				this.manualCost.importing = true
				return true
			},
			handleManualCostImportSuccess(response){
				this.manualCost.importing = false
				let res = response
				try{
					if(res && res.encryption){
						let enData = commondecrypt(res.encryption)
						res = JSON.parse(enData)
					}
				}catch(e){
					this.$message.error('导入响应解析失败')
					return
				}
				if(res && res.code==1){
					let data = res.data && res.data.list ? res.data.list : {}
					this.manualCost.pendingCosts = {}
					this.$message({
						message:'导入成功：' + (data.success || 0) + ' 条',
						type:'success'
					})
					this.reloadManualCostList()
				}else{
					this.$message.error(res && res.msg ? res.msg : '导入失败')
				}
			},
			handleManualCostImportError(){
				this.manualCost.importing = false
				this.$message.error('导入失败')
			},
			updateManualCostParentSums(productRow, accountRow){
				if(productRow && !productRow.cost_editable && productRow.data && productRow.data.length>0){
					let productTotal = productRow.data.reduce((total, item) => {
						return total + Number(item.manual_cost_money || 0)
					}, 0)
					productRow.manual_cost_money = this.formatManualCostMoney(productTotal)
				}
				if(accountRow){
					let serverTotal = accountRow.data && accountRow.data.length>0 ? accountRow.data.reduce((total, item) => {
						if(Number(item.use_service_cost || 0)!==1){
							return total
						}
						return total + Number(item.manual_cost_money || 0)
					}, 0) : Math.max(0, Number(accountRow.manual_cost_money || 0) - Number(accountRow.account_manual_cost_money || 0))
					let accountLevelCost = Number(accountRow.manual_cost_input || accountRow.account_manual_cost_money || 0)
					accountRow.account_manual_cost_money = this.formatManualCostMoney(accountLevelCost)
					accountRow.manual_cost_money = this.formatManualCostMoney(accountLevelCost + serverTotal)
				}
			},
			getManualCostPendingKey(row, level){
				return level + '-' + row.row_key
			},
			markManualCostDirty(row, level, productRow = null, accountRow = null){
				this.updateManualCostParentSums(productRow, accountRow)
				this.$set(this.manualCost.pendingCosts, this.getManualCostPendingKey(row, level), {
					row:row,
					level:level,
					productRow:productRow,
					accountRow:accountRow
				})
			},
			async forEachSingleManualCostEditable(callback){
				if(this.manualCost.list.length!=1){
					return null
				}
				let accountRow = this.manualCost.list[0]
				this.manualCost.loading = true
				try{
					if(!accountRow.data || accountRow.data.length==0){
						await this.openManualCostProduct(accountRow, true)
					}
					if(accountRow.account_cost_editable==1){
						callback(accountRow, 0, null, accountRow)
					}
					for(let i=0;i<accountRow.data.length;i++){
						let productRow = accountRow.data[i]
						if(productRow.use_service_cost==1 && productRow.has_detail==1){
							if(!productRow.data || productRow.data.length==0){
								await this.openManualCostService(productRow, true)
							}
							;(productRow.data || []).forEach(serviceRow => {
								callback(serviceRow, 2, productRow, accountRow)
							})
						}
					}
					this.updateManualCostParentSums(null, accountRow)
				}catch(err){
					console.log(err)
				}
				this.manualCost.loading = false
				return accountRow
			},
			async resetSingleManualCost(){
				await this.forEachSingleManualCostEditable((row, level, productRow, accountRow) => {
					if(level===0){
						row.manual_cost_input = '0.00'
					}else{
						row.manual_cost_money = '0.00'
					}
					this.markManualCostDirty(row, level, productRow, accountRow)
				})
			},
			async applySingleManualCostRatio(){
				let ratio = parseFloat(String(this.manualCost.costRatio).replace('%',''))
				if(isNaN(ratio)){
					ratio = 0
				}
				await this.forEachSingleManualCostEditable((row, level, productRow, accountRow) => {
					let baseTotal = Number(row.total || 0)
					if(level===0 && accountRow && accountRow.data && accountRow.data.length>0){
						baseTotal = accountRow.data.reduce((total, item) => {
							return total + (Number(item.use_service_cost || 0)===1 ? 0 : Number(item.total || 0))
						}, 0)
					}
					if(level===0){
						row.manual_cost_input = this.formatManualCostMoney(baseTotal * ratio / 100)
					}else{
						row.manual_cost_money = this.formatManualCostMoney(baseTotal * ratio / 100)
					}
					this.markManualCostDirty(row, level, productRow, accountRow)
				})
			},
			saveManualCostItem(item){
				let row = item.row
				let level = item.level
				let sourceMoney = level==0 ? row.manual_cost_input : row.manual_cost_money
				let money = sourceMoney === '' || sourceMoney === null ? 0 : sourceMoney
				return this.axios.post('/admin/data/saveManualCost', {
					date:row.date,
					uid:row.uid,
					cloud_id:row.cloud_id,
					account_id:row.account_id,
					product_id:level==0 ? 0 : row.product_id,
					service:level==2 ? row.cost_service : '',
					level:level,
					money:money
				}, {
					token: true,
				}).then(res => {
					if(res.data.code==1){
						if(level==0){
							row.manual_cost_input = this.formatManualCostMoney(money)
							row.account_manual_cost_money = row.manual_cost_input
						}else{
							row.manual_cost_money = this.formatManualCostMoney(money)
						}
						this.updateManualCostParentSums(item.productRow, item.accountRow)
						return true
					}
					return false
				}).catch(err => {
					console.log(err)
					return false
				})
			},
			saveManualCostAll(){
				let items = Object.keys(this.manualCost.pendingCosts).map(key => this.manualCost.pendingCosts[key])
				if(items.length==0){
					this.$message({
						message: '暂无需要保存的成本',
						type: 'info'
					})
					return
				}
				this.manualCost.saving = true
				Promise.all(items.map(item => this.saveManualCostItem(item))).then(res => {
					this.manualCost.saving = false
					if(res.every(item => item)){
						this.manualCost.pendingCosts = {}
						this.$message({
							message: '保存成功',
							type: 'success'
						})
						this.reloadManualCostList()
						this.getList()
					}else{
						this.$message({
							message: '部分成本保存失败，请重试',
							type: 'error'
						})
					}
				}).catch(err => {
					this.manualCost.saving = false
					console.log(err)
				})
			},
			
			checkAgainList(){
				this.layout.loading = true;
				this.axios.post('/admin/data/checkAgentList', {}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.layout.loading = false;
					
					if(res.data.code==1){
						this.checkAgainData = list
					}
					
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
					//this.copyDataModel = false
				})
			},
			
			cancelORderAgain(row){
				
					this.$confirm(this.$t('monList.againTis'), this.$t('system.prompt'), {
						confirmButtonText: this.$t('monList.ok'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}).then(() => {					
						this.layout.loading = true;
						this.axios.post('/admin/data/cancelAgent', row, {
							token: true,
						}).then(res => {
							let all = res.data
							let list = all.data.list
							
							this.layout.loading = false;
							
							if(res.data.code==1){
								this.checkAgainList()
							}
							
							
						}).catch(err => {
							// 失敗
							this.layout.loading = false;
							//this.copyDataModel = false
						})
					})
				
				
				
			},
			
			checkAgainExternalBill(row){
				this.layout.loading = true;
				this.axios.post('/admin/data/checkAgainExternalBill', {id:row.id}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					if(res.data.code==1){
						let data = res.data.data || {}
						this.$set(row,'external_check_status',data.has_data==1?1:0)
						this.$set(row,'external_count',data.external_count || 0)
						this.$set(row,'external_last_time',data.external_last_time || '-')
						this.$set(row,'external_check_text',data.msg || '')
						if(data.has_data==1){
							this.$message.success(data.msg || '外部账单库已有数据')
						}else{
							this.$message.warning(data.msg || '外部账单库暂未查到账单数据')
						}
					}
				}).catch(err => {
					this.layout.loading = false;
				})
			},

			finishAgainExternalBill(row){
				this.$confirm('确认直接从外部账单库入库并完成本次重拉？', this.$t('system.prompt'), {
					confirmButtonText: this.$t('monList.ok'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.axios.post('/admin/data/finishAgainExternalBill', {id:row.id}, {
						token: true,
					}).then(res => {
						this.layout.loading = false;
						if(res.data.code==1){
							this.$message.success(this.$t('system.success'))
							this.checkAgainList()
							this.getList()
						}
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			
			
			tlSubModel(){
				this.$refs.form_tl.validate(res => {
					if (res) {
						
						this.tlOddsApi()
						//this.copy = false
					}
				})
			},
			
			
			tlOddsApi(data){
				this.tl.load = true
				this.axios.post('/admin/data/autoAddTlMoney', this.tl, {
					token: true,
				}).then(res => {
					
					let all = res.data
					let list = all.data.list
					//data.row.data = list
					
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					this.tl.load = false
					this.tlModel = false
					this.getList()
				}).catch(err => {
					// 失敗
					this.tl.load = false
					console.log(err)
				})
				
				
				
			},
			
			addOrderLog(){
				const row = { ...this.detailTemplate } // 简单深拷贝够用（字段都是原始类型）
				this.form.detail.push(row)
			},
			delOrderLog(index) {
			  this.form.detail.splice(index, 1)
			  if (this.form.detail.length === 0) {
				this.form.detail.push({ ...this.detailTemplate })
			  }
			},
			selProduct(e){
				// console.log(e)
				// let index = this.agentData.product.findIndex(item=>item.id==e)
				// console.log(this.agentData.product[index])
				// if(index != -1){
				// 	this.is_odds = this.agentData.product[index].is_odds
				// }else{
				// 	this.is_odds = 1;
				// }
			},
			selHlAccount(e){
				let selected = e || [];
				
				  // 清空：强制设为 [0]
				  if (selected.length === 0) {
				    this.other.account_id = [0];
				  }
				  // 如果选中 0 和其他，去掉 0
				  else if (selected.includes(0) && selected.length > 1) {
				    this.other.account_id = selected.filter(id => id !== 0);
				  }
				  // 正常情况：直接赋值
				  else {
				    this.other.account_id = selected;
				  }
				
				  // 控制台查看确认
				  console.log('当前选中:', this.other.account_id);
			},
			selHlAccount2(e){
				let selected = e || [];
				
				  // 清空：强制设为 [0]
				  if (selected.length === 0) {
				    this.excel.account_id = [0];
				  }
				  // 如果选中 0 和其他，去掉 0
				  else if (selected.includes(0) && selected.length > 1) {
				    this.excel.account_id = selected.filter(id => id !== 0);
				  }
				  // 正常情况：直接赋值
				  else {
				    this.excel.account_id = selected;
				  }
				
			},
			changeAccount(e){
				let index = this.account.findIndex(item=>item.id==e)
				this.form.odds = this.account[index].odds
			},
			refreshDialogAccountList(type){
				let cloud_id = ''
				if(type=='other'){
					cloud_id = this.other.cloud_id
				}else if(type=='again'){
					cloud_id = this.again.cloud_id
				}else if(type=='tl'){
					cloud_id = this.tl.cloud_id
				}else if(type=='copy'){
					cloud_id = this.copyData.cloud_id
				}else if(type=='excel'){
					cloud_id = this.excel.cloud_id
				}
				if(cloud_id && Number(cloud_id) !== 0){
					this.$nextTick(() => {
						this.commonList('orderAccount', cloud_id, type)
					})
				}
			},
			changeCloud(e, source = ''){
				console.log(e)
				this.account = []
				this.form.account_id = ''
				this.other.account_id = [0]
				this.excel.account_id = [0]
				this.again.account_id = []
				this.tl.account_id = ''
				this.copyData.aid = ''
				if(e!=0){
					this.commonList('orderAccount', e, source);
				}
			},
			changeOrderAccountFilter(){
				this.form.account_id = ''
				if(this.form.cloud_id){
					this.commonList('orderAccount', this.form.cloud_id, 'form');
				}
			},
			changeAccountFilter(type){
				let cloud_id = ''
				this.account = []
				if(type=='other'){
					this.other.account_id = [0]
					cloud_id = this.other.cloud_id
				}
				if(type=='again'){
					this.again.account_id = []
					cloud_id = this.again.cloud_id
				}
				if(type=='copy'){
					this.copyData.aid = ''
					cloud_id = this.copyData.cloud_id
				}
				if(type=='tl'){
					this.tl.account_id = ''
					cloud_id = this.tl.cloud_id
				}
				if(cloud_id){
					this.commonList('orderAccount', cloud_id, type);
				}
			},
			changeProviderSupplier(){
				this.excel.account_id = [0]
				if(this.excel.cloud_id){
					this.commonList('orderAccount', this.excel.cloud_id, 'excel');
				}
			},
			changeSup(e){
				this.excel.account_id = [0]
				if(this.excel.cloud_id){
					this.commonList('orderAccount', this.excel.cloud_id, 'excel');
				}
			},
			
			copyOrder(row){
				this.copyData.row = row
				
				this.copyData.product_id = row.product_id
				this.copyData.copy_type = 'product'
				this.copyData.has_live_product = row.product_id==4?1:0
				this.copyData.aid = ''
				this.copyData.cloud_id  = row.cloud_id || ''
				this.copyData.addOdds  = 0
				this.copyData.supplier_id = ''
				this.copyData.sup_id = ''
				this.copyDataModel = true
				this.refreshDialogAccountList('copy')
			},
			copyAccountOrder(row){
				this.copyData.row = row
				this.copyData.product_id = 0
				this.copyData.copy_type = 'account'
				this.copyData.has_live_product = row.has_live_product==1?1:0
				this.copyData.aid = ''
				this.copyData.cloud_id  = row.cloud_id || ''
				this.copyData.addOdds  = 0
				this.copyData.supplier_id = ''
				this.copyData.sup_id = ''
				this.copyDataModel = true
				this.refreshDialogAccountList('copy')
			},
			
			
			
			copyNewOrderModel(){
				this.$refs.form_copy.validate(res => {
					if (res) {
						
						this.copyOrderApi()
						//this.copy = false
					}
				})
			},
			delLogLog(row,parent){
					console.log(row)
					this.$confirm(this.$t('monList.againTis'), this.$t('system.prompt'), {
						confirmButtonText: this.$t('monList.ok'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}).then(() => {
						this.axios.post('/admin/data/delOrderLogLog', {now:row,parent:parent}, {
							token: true,
						}).then(res => {
							let all = res.data
							let list = all.data.list
							//data.row.data = list
							console.log(list)
							this.getList()
						}).catch(err => {
							// 失敗
							data.row.load  = false;
							this.again.load = false
						})
					})
				
			},
			copyOrderApi(){
				this.layout.loading = true;
				this.axios.post('/admin/data/copyOrder', this.copyData, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.layout.loading = false;
					
					
					if(res.data.code==1){
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.copyDataModel = false
						this.getList()
						
						
					}
					
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
					//this.copyDataModel = false
				})
			},
			againNewOrderModel(){
				this.$refs.form_again.validate(res => {
					if (res) {
						console.log(this.again)
						// let info = this.account.find(item=>item.id==this.again.account_id)
						// if(!info){
						// 	return false;
						// }
						// let datas = {
						// 	row:{
						// 		date:this.again.date,
						// 		account_id:this.again.account_id,
						// 		uid:info.uid,
						// 		load:false,
						// 	},
						// 	type:'again'
						// }
						
						this.againNewOrderMore()
						this.againModel = false
					}
				})
			},
			
			againNewOrderMore(){

				this.again.load = true
				this.axios.post('/admin/data/againNewOrderMore', this.again, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
				
					this.again.load = false
					this.getList()
				}).catch(err => {
					// 失敗
					this.again.load = false
				})
			},
			
		
			
			
			againNewOrder(data){
				if(data.type=='copy'){
					this.copyAccountOrder(data.row)
					return
				}
				if(data.type=='againOdds'){
					this.againOdds(data.row,data.level)
					return
				}
				
				if(data.type=='difference'){
					this.again.load = true
					this.axios.post('/admin/data/orderDiscrepancyHandling', {
						aid:data.row.account_id,
						date:data.row.date
					}, {
						token: true,
					}).then(res => {
						console.log(11111)
						this.again.load = false
						this.getList()
					}).catch(err => {
						// 失敗
						this.again.load = false
					})
				}else{
					this.$confirm(this.$t('monList.againTis'), this.$t('system.prompt'), {
						confirmButtonText: this.$t('monList.ok'),
						cancelButtonText: this.$t('system.cancel'),
						type: 'warning'
					}).then(() => {
						console.log(data)
						let nUid = 0;
						if(data.row.uid){
							nUid = data.row.uid
						}
						
						
						
						data.row.load  = true;
						this.again.load = true
						this.axios.post('/admin/data/againNewOrderMore', {
							account_id:[data.row.account_id],
							date:data.row.date,
							cloud_id:data.row.cloud_id,
							type:data.type,
							pull_mode:data.pull_mode || 'remote',
							nuid:nUid
						}, {
							token: true,
						}).then(res => {
							let all = res.data
							let list = all.data.list
							//data.row.data = list
						
							data.row.load = false;
							this.again.load = false
							this.getList()
						}).catch(err => {
							// 失敗
							data.row.load  = false;
							this.again.load = false
						})
					})
				}

				
				
				
				
			},
			openTable(row){
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/monDetail', {
						uid:row.uid,
						date:row.date,
						ac_id:this.ac_id,
						supplier_id:this.from.supplier_id,
						sup_id:this.from.sup_id,
						type:1
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			openTable2(row){
				
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/monDetail', {
						uid:row.uid,
						date:row.date,
						cloud_id:row.cloud_id,
						ac_id:this.ac_id,
						supplier_id:this.from.supplier_id,
						sup_id:this.from.sup_id,
						type:2
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						//console.log(list)
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			
			openTable3(row){
				console.log(row)
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/monDetail', {
						uid:row.uid,
						date:row.date,
						account_id:row.account_id,
						need_money:row.need_money,
						total:row.total,
						ac_id:this.ac_id,
						supplier_id:this.from.supplier_id,
						sup_id:this.from.sup_id,
						type:3
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						console.log(list)
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			
			
			openTable4(row){
				console.log(row)
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/monDetail', {
						uid:row.uid,
						id:row.id,
						date:row.date,
						cloud_id:row.cloud_id,
						account_id:row.account_id,
						product_id:row.product_id,
						total:row.total,
						need_money:row.need_money,
						ac_id:this.ac_id,
						supplier_id:this.from.supplier_id,
						sup_id:this.from.sup_id,
						type:4
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						console.log(list)
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			
			
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 2
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			
			
			
			
			submitOther(){
				this.$refs.form_other.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						this.changeUsdToOrder()
					}
				})
			},
			changeUsdToOrder(){
				this.layout.loading = true;
				this.axios.post('/admin/data/changeUsdToOrder', this.other, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.otherModel = false
					
					this.getList()
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
				
			},
			excelSetSub(){
				this.$refs.form_excel.validate(res => {

					if (res) {
						this.downExcelApi('set')
					}
				})
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.charge_type = 1
						this.form.id = this.editIndex
						this.addOrEdit(this.form,true)
						// 關閉模态框
					}
				})
			},
			openAgainModel(e = false){
				this.again.type = 'again'
				this.again.pull_mode = 'remote'
				this.again.supplier_id = ''
				this.again.sup_id = ''
				this.again.account_id = []
				this.account = []
				// 打开dialog
				this.againModel = true
				this.refreshDialogAccountList('again')
			},
			
			openOtherModel(e = false){
				this.other.supplier_id = ''
				this.other.sup_id = ''
				this.other.account_id = [0]
				this.account = []
				// 打开dialog
				this.otherModel = true
				this.refreshDialogAccountList('other')
			},

			// 打开模态框
			openModel(e = false) {
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24);
				// 增加
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						order_no:'',
						id:0,
						type: 1,
						cloud_id: '',
						account_id:'',
						supplier_id:'',
						sup_id:'',
						product_id:'',
						odds:100,
						log_type:1,
						use_num:'',
						money:'',
						date:'',
							add_type:1,
							charge_type:1,
							unit:'',
							detail:[],
							remark:''
					}
					
					const row = { ...this.detailTemplate } // 简单深拷贝够用（字段都是原始类型）
					this.form.detail.push(row)
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						supplier_id: e.supplier_id || '',
						sup_id: e.sup_id || '',
						focus:e.focus,
						username: e.username,
						password: e.password,
						log_type: e.log_type,
						use_num: e.use_num,
						product_id: e.product_id,
						status: e.status,
							money:e.money,
							money_type:e.money_type,
							charge_type:e.charge_type || 1,
							remark:e.remark
						}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			
			
			
			downExcel(type){
				//console.log(type)
				if(type=='set'){
					this.excelModel = true
					this.refreshDialogAccountList('excel')
				}else{
					this.downExcelApi(type)
				}
				
					
				
			},
			
			
			
			downExcelApi(type){
				//console.log(type)
				if(type=='sel'){
					if(this.ids.length<1){
						 this.$message.error(this.$t('new1.selinfo'));
						return false
					}
				}
				
				var datato = {}
				if(type=='set'){
					datato = this.excel
				}else{
					datato = {search:this.from,ids:this.ids,type:type}
				}
				this.downExcelApi
				
					console.log(this.ids)
					this.layout.loading = true;
					this.axios.post('/admin/data/dowmExcel', datato, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						
						console.log(list)
						
						this.layout.loading = false;
						
						const link = document.createElement('a');
						link.href = list;
						link.download = ''; // 留空会自动用原文件名，也可以写 '報表.pdf'
						link.target = '_blank'; // 避免弹窗拦截
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
			
						
					}).catch(err => {
						// 失敗
						this.layout.loading = false;
					})
				
			},
			
			
			againOdds(row,level){
				
				this.odds.row = row
				this.odds.now = row.odds
				this.odds.level = Number(level || row.type || 3)
				this.odds.service = row.service || row.cost_service || row.pro_name || ''
				this.odds.account_id = row.account_id || row.aid || 0
				this.odds.cloud_id = row.cloud_id || 0
				this.odds.product_id = row.product_id || 0
				this.odds.date = row.date || ''
				this.oddsModel = true
				
			},
			canAgainOdds(row,parentRow,level){
				if(!row){
					return false
				}
				let productId = Number(row.product_id || 0)
				let service = String(row.service || row.cost_service || row.pro_name || '')
				let type = Number(level || row.type || 3)
				let isOk = parentRow ? Number(parentRow.is_ok || 0) : 0
				if(type==2){
					return Number(row.account_id || row.aid || 0)>0 && isOk==0
				}
				return [3,4].includes(type) && productId>0 && productId!=4 && productId!=111 && service!='dis_money' && isOk==0
			},
			canFillPendingServerPrice(row,parentRow){
				if(!row){
					return false
				}
				let service = String(row.service || row.cost_service || row.pro_name || '')
				let type = Number(row.type || 4)
				let isOk = parentRow ? Number(parentRow.is_ok || 0) : 0
				return type==4 && Number(row.server_price_status || 0)==1 && service!='' && service!='dis_money' && isOk==0
			},
			canDeleteServerBillDetail(row,billRow,accountRow){
				if(!row || !billRow || !accountRow){
					return false
				}
				let serverCloudIds = [23, 37]
				let service = String(row.service || row.cost_service || row.pro_name || '')
				return Number(billRow.is_ok || 0)==0 && serverCloudIds.includes(Number(accountRow.cloud_id || 0)) && Number(row.product_id || 0)==1 && service!='' && service!='dis_money'
			},
			openPendingServerPriceList(row = null){
				this.pendingServerPriceBatch.row = row || {}
				this.pendingServerPriceBatch.support_month = this.defaultPendingSupportMonth(row || {})
				this.pendingServerPriceBatch.list = []
				this.pendingServerPriceListModel = true
				this.loadPendingServerPriceList()
			},
			defaultPendingSupportMonth(row = {}){
				if(row.date){
					return this.monthValueWithOffset(row.date, -1)
				}
				return this.monthValueWithOffset('', -1)
			},
			monthValueWithOffset(value, offset = 0){
				let date = value ? new Date(String(value).replace(/-/g, '/')) : new Date()
				if(isNaN(date.getTime())){
					date = new Date()
				}
				date.setDate(1)
				date.setMonth(date.getMonth() + offset)
				const year = date.getFullYear()
				const month = String(date.getMonth() + 1).padStart(2, '0')
				return `${year}-${month}-01`
			},
			loadPendingServerPriceList(){
				let row = this.pendingServerPriceBatch.row || {}
				this.pendingServerPriceBatch.loading = true
				this.axios.post('/admin/data/pendingServerPriceList', {
					id:row.id || 0,
					uid:row.uid || this.from.name || 0,
					date: row.date || this.from.time || '',
					support_month: this.pendingServerPriceBatch.support_month,
					use_filter: row.id ? 0 : 1,
					cloud_id: this.from.cloud_id,
					supplier_id: this.from.supplier_id,
					sup_id: this.from.sup_id,
					username: this.from.username,
				}, {
					token: true,
				}).then(res => {
					let data = res.data.data || {}
					let list = data.list || []
					this.pendingServerPriceBatch.list = list.map(item => {
						item.input_order_money = item.input_order_money || ''
						if(item.pending_type=='amazon_support'){
							item.input_cost_money = ''
						}else{
							item.input_cost_money = item.input_cost_money !== '' && item.input_cost_money !== null && item.input_cost_money !== undefined ? item.input_cost_money : 0
						}
						item.input_odds = item.input_odds || 100
						item.saving = false
						return item
					})
					this.pendingServerPriceBatch.loading = false
				}).catch(err => {
					this.pendingServerPriceBatch.loading = false
				})
			},
			pendingServerPriceRowFilled(row){
				if(!row){
					return false
				}
				let baseFilled = row.input_order_money !== '' && row.input_order_money !== null && row.input_order_money !== undefined
					&& row.input_odds !== '' && row.input_odds !== null && row.input_odds !== undefined
				if(row.pending_type=='amazon_support'){
					return baseFilled
				}
				return baseFilled && row.input_cost_money !== '' && row.input_cost_money !== null && row.input_cost_money !== undefined
			},
			validatePendingServerPriceRow(row){
				let orderMoney = parseFloat(row.input_order_money)
				let isAmazonSupport = row && row.pending_type=='amazon_support'
				let costMoney = isAmazonSupport ? 0 : parseFloat(row.input_cost_money)
				let odds = parseFloat(row.input_odds)
				if(isNaN(orderMoney) || orderMoney<0){
					this.$message.error('请输入正确的销售价')
					return false
				}
				if(!isAmazonSupport && (isNaN(costMoney) || costMoney<0)){
					this.$message.error('请输入正确的成本金额')
					return false
				}
				if(isNaN(odds) || odds<=0){
					this.$message.error('请输入正确的折扣')
					return false
				}
				return { orderMoney, costMoney, odds }
			},
			savePendingServerPriceRow(row, options = {}){
				let data = this.validatePendingServerPriceRow(row)
				if(!data){
					return Promise.resolve(false)
				}
				this.$set(row, 'saving', true)
				let postData = {
					pending_type:row.pending_type || 'server',
					detail_id:row.detail_id,
					log_id:row.log_id,
					service:row.service,
					date:row.date,
					uid:row.uid,
					account_id:row.account_id,
					cloud_id:row.cloud_id,
					product_id:row.product_id,
					order_money:data.orderMoney,
					odds:data.odds,
				}
				if(row.pending_type!='amazon_support'){
					postData.cost_money = data.costMoney
				}
				return this.axios.post('/admin/data/savePendingServerPrice', postData, {
					token: true,
				}).then(res => {
					this.$set(row, 'saving', false)
					if(!options.skipReload){
						this.loadPendingServerPriceList()
						this.getList()
					}
					return true
				}).catch(err => {
					this.$set(row, 'saving', false)
					return false
				})
			},
			async savePendingServerPriceAll(){
				if(this.pendingServerPriceBatch.loading || this.pendingServerPriceBatch.saving){
					return
				}
				let rows = (this.pendingServerPriceBatch.list || []).filter(row => this.pendingServerPriceRowFilled(row))
				if(rows.length===0){
					this.$message.info('暂无已填写完整的待保存价格')
					return
				}
				this.pendingServerPriceBatch.saving = true
				let success = 0
				for(let row of rows){
					let ok = await this.savePendingServerPriceRow(row, { skipReload:true })
					if(ok){
						success++
					}
				}
				this.pendingServerPriceBatch.saving = false
				if(success===rows.length){
					this.$message.success(`保存成功，共${success}条`)
				}else{
					this.$message.warning(`已保存${success}条，${rows.length-success}条保存失败`)
				}
				this.loadPendingServerPriceList()
				this.getList()
			},
			openPendingServerPrice(row){
				this.pendingServerPrice = {
					row:row,
					service:row.service || row.cost_service || row.pro_name || '',
					order_money:Number(row.order_money || 0)>0 ? row.order_money : '',
					cost_money:Number(row.cost_money || 0)>0 ? row.cost_money : 0,
					odds:100
				}
				this.pendingServerPriceModel = true
			},
			savePendingServerPriceApi(){
				let orderMoney = parseFloat(this.pendingServerPrice.order_money)
				let costMoney = parseFloat(this.pendingServerPrice.cost_money)
				let odds = parseFloat(this.pendingServerPrice.odds)
				if(isNaN(orderMoney) || orderMoney<0){
					this.$message.error('请输入正确的销售价')
					return false
				}
				if(isNaN(costMoney) || costMoney<0){
					this.$message.error('请输入正确的成本金额')
					return false
				}
				if(isNaN(odds) || odds<=0){
					this.$message.error('请输入正确的折扣')
					return false
				}
				this.layout.loading = true;
				this.axios.post('/admin/data/savePendingServerPrice', {
					log_id:this.pendingServerPrice.row.id,
					service:this.pendingServerPrice.service,
					order_money:orderMoney,
					cost_money:costMoney,
					odds:odds,
				}, {
					token: true,
				}).then(res => {
					this.layout.loading = false;
					this.pendingServerPriceModel = false
					this.getList()
				}).catch(err => {
					this.layout.loading = false;
				})
			},
			againOddsApi(){
		
				this.layout.loading = true;
				this.axios.post('/admin/data/againOdds', {
					id:this.odds.row.id,
					odds:this.odds.odds,
					level:this.odds.level,
					service:this.odds.service,
					account_id:this.odds.account_id,
					cloud_id:this.odds.cloud_id,
					product_id:this.odds.product_id,
					date:this.odds.date,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.layout.loading = false;
					this.oddsModel = false
					this.getList()
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			pdfMergeAccountLabel(row){
				if(!row){
					return ''
				}
				let account = row.ac_id || row.account_id || row.aid || ''
				let username = row.username || row.user_name || ''
				let cloudName = row.cloud_name || row.c_name || ''
				let label = account ? String(account) : '账号'
				if(username){
					label += ' (' + username + ')'
				}
				if(cloudName){
					label += ' - ' + cloudName
				}
				return label
			},
			canOpenPdfMerge(row,cloudRow){
				if(!row || !cloudRow){
					return false
				}
				if(Number(row.pay_type || 1) === 2){
					return false
				}
				return Number(row.account_id || row.aid || 0)>0 && Number(cloudRow.uid || 0)>0 && !!cloudRow.date
			},
			pdfMergeSelectedRows(cloudRow){
				let rows = Array.isArray(cloudRow && cloudRow.data) ? cloudRow.data : []
				return rows.filter(item => item && item.is_sel && Number(item.account_id || item.aid || 0)>0).map(item => {
					return Object.assign({}, item, {
						account_id:Number(item.account_id || item.aid || 0)
					})
				})
			},
			isPdfMergeSourceDisabled(accountId,index){
				accountId = Number(accountId || 0)
				return this.pdfMerge.rules.some((rule,idx) => {
					return idx !== index && Number(rule.source_account_id || 0) === accountId
				})
			},
			addPdfMergeRule(){
				let accounts = this.pdfMerge.selected_accounts || []
				let used = {}
				this.pdfMerge.rules.forEach(rule => {
					if(Number(rule.source_account_id || 0)>0){
						used[Number(rule.source_account_id)] = 1
					}
				})
				let source = accounts.find(item => Number(item.pay_type || 1)!==2 && !used[Number(item.account_id)])
				if(!source){
					this.$message.warning('没有可继续合并的来源账号')
					return false
				}
				let target = accounts.find(item => Number(item.pay_type || 1)!==2 && Number(item.account_id)!==Number(source.account_id))
				if(!target){
					this.$message.warning('至少需要两个非预付费账号才能合并')
					return false
				}
				this.pdfMerge.rules.push({
					source_account_id:Number(source.account_id),
					target_account_id:Number(target.account_id)
				})
			},
			removePdfMergeRule(index){
				this.pdfMerge.rules.splice(index,1)
			},
			normalizedPdfMergeRules(showMessage=false){
				let selectedIds = {}
				;(this.pdfMerge.selected_accounts || []).forEach(item => {
					selectedIds[Number(item.account_id)] = item
				})
				let sourceUsed = {}
				let targetSet = {}
				let rules = []
				for(let i=0;i<(this.pdfMerge.rules || []).length;i++){
					let source = Number(this.pdfMerge.rules[i].source_account_id || 0)
					let target = Number(this.pdfMerge.rules[i].target_account_id || 0)
					if(!source && !target){
						continue
					}
					if(!source || !target){
						if(showMessage){ this.$message.error('请完善合并规则') }
						return false
					}
					if(source === target){
						if(showMessage){ this.$message.error('来源账号和显示账号不能相同') }
						return false
					}
					if(!selectedIds[source] || !selectedIds[target]){
						if(showMessage){ this.$message.error('合并规则只能选择已勾选导出的账号') }
						return false
					}
					if(Number(selectedIds[source].pay_type || 1)===2 || Number(selectedIds[target].pay_type || 1)===2){
						if(showMessage){ this.$message.error('预付费账号暂不支持合并') }
						return false
					}
					if(sourceUsed[source]){
						if(showMessage){ this.$message.error('同一个来源账号只能合并一次') }
						return false
					}
					sourceUsed[source] = 1
					targetSet[target] = 1
					rules.push({
						source_account_id:source,
						target_account_id:target
					})
				}
				for(let source in sourceUsed){
					if(targetSet[source]){
						if(showMessage){ this.$message.error('不支持链式合并，请直接合并到最终显示账号') }
						return false
					}
				}
				if(rules.length===0){
					if(showMessage){ this.$message.error('请至少添加一条合并规则') }
					return false
				}
				return rules
			},
			canSubmitPdfMerge(){
				if(this.pdfMerge.mode === 'selected'){
					return !!this.normalizedPdfMergeRules(false)
				}
				return this.pdfMerge.source_account_ids && this.pdfMerge.source_account_ids.length>0
			},
			openPdfMergeModel(row,cloudRow){
				if(!this.canOpenPdfMerge(row,cloudRow)){
					this.$message.error('暂无可合并的账号')
					return false
				}
				let accountId = Number(row.account_id || row.aid || 0)
				this.pdfMerge = {
					mode:'single',
					row:row,
					cloudRow:cloudRow,
					selectedCloudRow:{},
					selected_cloud_id:0,
					target_account_id:accountId,
					target_label:this.pdfMergeAccountLabel(row),
					source_account_ids:[],
					selected_accounts:[],
					rules:[],
					accounts:[],
					loading:true
				}
				this.pdfMergeModel = true
				this.axios.post('/admin/data/pdfMergeAccountList', {
					uid:cloudRow.uid,
					date:cloudRow.date,
					account_id:accountId,
					supplier_id:this.from.supplier_id,
					sup_id:this.from.sup_id,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list || []
					this.pdfMerge.accounts = list.filter(item => {
						return Number(item.account_id || 0)>0 && Number(item.account_id || 0)!==accountId
					})
					this.pdfMerge.loading = false
					if(this.pdfMerge.accounts.length===0){
						this.$message.warning('当前客户该月份暂无可合并的其他账号')
					}
				}).catch(err => {
					this.pdfMerge.loading = false
				})
			},
			openSelectedPdfMergeModel(row,cloudRow){
				let selected = this.pdfMergeSelectedRows(cloudRow)
				if(selected.length===0){
					this.$message.error(this.$t('monList.seldownsel'))
					return false
				}
				if(selected.length<2){
					this.$message.error('至少选择两个账号才能合并下载')
					return false
				}
				this.pdfMerge = {
					mode:'selected',
					row:{},
					cloudRow:row,
					selectedCloudRow:cloudRow,
					selected_cloud_id:Number(cloudRow.cloud_id || 0),
					target_account_id:0,
					target_label:'',
					source_account_ids:[],
					selected_accounts:selected,
					rules:[],
					accounts:selected,
					loading:false
				}
				this.pdfMergeModel = true
				this.addPdfMergeRule()
			},
			submitPdfMerge(){
				if(this.pdfMerge.mode === 'selected'){
					let rules = this.normalizedPdfMergeRules(true)
					if(!rules){
						return false
					}
					this.printPdf(this.pdfMerge.cloudRow,this.pdfMerge.selected_cloud_id,2,1,this.pdfMerge.selectedCloudRow,{
						merge_rules:rules
					})
					this.pdfMergeModel = false
					return true
				}
				if(!this.pdfMerge.source_account_ids || this.pdfMerge.source_account_ids.length===0){
					this.$message.error('请选择要合并的账号')
					return false
				}
				this.printPdf(this.pdfMerge.cloudRow,this.pdfMerge.target_account_id,3,0,{},{
					merge_account_ids:this.pdfMerge.source_account_ids,
					merge_target_account_id:this.pdfMerge.target_account_id
				})
				this.pdfMergeModel = false
			},
			handleAccountPdfCommand(data){
				if(data.type === 'mergePdf'){
					this.openPdfMergeModel(data.row,data.cloudRow)
				}
			},
			printPdf(row,type_id=0,type=1,is_sel=0,self_row={},options={}) {
				let ids = []
			
				if (type === 2 && is_sel === 1) {
				  if (!self_row.data || self_row.data.length === 0) {
				    this.$message.error(this.$t('monList.nodownsel'))
				    return false
				  }
				
				  ids = self_row.data
				    .filter(item => item.is_sel)
				    .map(item => item.account_id)
				  if(ids.length==0){
					  this.$message.error(this.$t('monList.seldownsel'))
					  return false
				  }
				}
				
				this.layout.loading = true;
				this.axios.post('/admin/data/printPdf', {
					id: row.id,
					type_id:type_id,
					type:type,
					is_sel:is_sel,
					ids:ids,
					supplier_id:this.from.supplier_id,
					sup_id:this.from.sup_id,
					merge_account_ids:options.merge_account_ids || [],
					merge_target_account_id:options.merge_target_account_id || 0,
					merge_rules:options.merge_rules || []
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.layout.loading = false;
					console.log(list)
					
					const link = document.createElement('a');
					link.href = list;
					link.download = ''; // 留空会自动用原文件名，也可以写 '報表.pdf'
					link.target = '_blank'; // 避免弹窗拦截
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			confirmOrder(id,type){
				let title = this.$t('monList.is_ok_title')
				if(type==2){
					 title = this.$t('monList.is_ok_title2')
				}
				
				this.$confirm(title, this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					let url = '/admin/data/confirmOrder'
					this.axios.post(url, {
						id: id,
						type:type
					}, {
						token: true,
						loading: true
					}).then(res => {
						if(res.data.code==1){
							this.$message({
								message: res.data.msg,
								type: 'success'
							});
							this.getList()
						}
				
						
						//this.layout.getPageNum()
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			//公共列表
			commonList(type,id=0, source = '') {
				this.account = [];
				this.layout.loading = true;
				let supplier_id = ''
				let sup_id = ''
				if(type=='orderAccount'){
					if(source=='excel'){
						supplier_id = this.excel.supplier_id && this.excel.supplier_id!=-1 ? this.excel.supplier_id : ''
						sup_id = this.excel.sup_id && this.excel.sup_id!=-1 ? this.excel.sup_id : ''
					}else if(source=='form'){
						supplier_id = this.form.supplier_id && this.form.supplier_id!=-1 ? this.form.supplier_id : ''
						sup_id = this.form.sup_id && this.form.sup_id!=-1 ? this.form.sup_id : ''
					}else if(source=='other'){
						supplier_id = this.other.supplier_id && this.other.supplier_id!=-1 ? this.other.supplier_id : ''
						sup_id = this.other.sup_id && this.other.sup_id!=-1 ? this.other.sup_id : ''
					}else if(source=='again'){
						supplier_id = this.again.supplier_id && this.again.supplier_id!=-1 ? this.again.supplier_id : ''
						sup_id = this.again.sup_id && this.again.sup_id!=-1 ? this.again.sup_id : ''
					}else if(source=='copy'){
						supplier_id = this.copyData.supplier_id && this.copyData.supplier_id!=-1 ? this.copyData.supplier_id : ''
						sup_id = this.copyData.sup_id && this.copyData.sup_id!=-1 ? this.copyData.sup_id : ''
					}else if(source=='tl'){
						supplier_id = this.tl.supplier_id && this.tl.supplier_id!=-1 ? this.tl.supplier_id : ''
						sup_id = this.tl.sup_id && this.tl.sup_id!=-1 ? this.tl.sup_id : ''
					}else if(this.excelModel){
						supplier_id = this.excel.supplier_id && this.excel.supplier_id!=-1 ? this.excel.supplier_id : ''
						sup_id = this.excel.sup_id && this.excel.sup_id!=-1 ? this.excel.sup_id : ''
					}else if(this.createModel && this.editIndex <= -1){
						supplier_id = this.form.supplier_id && this.form.supplier_id!=-1 ? this.form.supplier_id : ''
						sup_id = this.form.sup_id && this.form.sup_id!=-1 ? this.form.sup_id : ''
					}else if(this.otherModel){
						supplier_id = this.other.supplier_id && this.other.supplier_id!=-1 ? this.other.supplier_id : ''
						sup_id = this.other.sup_id && this.other.sup_id!=-1 ? this.other.sup_id : ''
					}else if(this.againModel){
						supplier_id = this.again.supplier_id && this.again.supplier_id!=-1 ? this.again.supplier_id : ''
						sup_id = this.again.sup_id && this.again.sup_id!=-1 ? this.again.sup_id : ''
					}else if(this.copyDataModel){
						supplier_id = this.copyData.supplier_id && this.copyData.supplier_id!=-1 ? this.copyData.supplier_id : ''
						sup_id = this.copyData.sup_id && this.copyData.sup_id!=-1 ? this.copyData.sup_id : ''
					}else if(this.tlModel){
						supplier_id = this.tl.supplier_id && this.tl.supplier_id!=-1 ? this.tl.supplier_id : ''
						sup_id = this.tl.sup_id && this.tl.sup_id!=-1 ? this.tl.sup_id : ''
					}
				}
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id,
					supplier_id:supplier_id,
					sup_id:sup_id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					if(type=='account'){
						this.agentData = list
					}else{
						//console.log(list)
						this.account = list.account
					}
					

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.ac_id = e.ac_id
				this.other.date = this.from.time || e.mon
				this.total = e.total_list
				this.loadBillConfirmStatus()
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					cloud_id:-1,
					supplier_id:-1,
					sup_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.manual-cost-dialog .el-dialog__body {
  max-height: calc(90vh - 140px);
  overflow: auto;
}

.bill-confirm-dialog .el-dialog__body {
  display: flex;
  flex-direction: column;
  max-height: calc(90vh - 104px);
  overflow: hidden;
}

.bill-confirm-table-wrap {
  flex: 1 1 auto;
  min-height: 180px;
  overflow: auto;
}

.bill-confirm-pagination {
  display: flex;
  justify-content: flex-start;
  min-width: 0;
}

.bill-confirm-pagination .el-pagination {
  white-space: nowrap;
}

.bill-confirm-footer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
}

.bill-confirm-footer-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-wrap: nowrap;
}

.bill-confirm-footer-actions {
  flex: 0 0 auto;
}

.bill-confirm-badge {
  vertical-align: middle;
}

.bill-confirm-previous-diff {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}

.manual-cost-dialog .el-table__expanded-cell {
  padding: 0 !important;
}

.manual-cost-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
}

.manual-cost-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.manual-cost-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.manual-cost-summary-item {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 3px 9px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
}

.manual-cost-summary-item strong {
  margin-left: 2px;
  font-size: 13px;
  font-weight: 700;
}

.manual-cost-summary-order {
  color: #52a318;
  background: #f0f9eb;
  border-color: #d7edc8;
}

.manual-cost-summary-total {
  color: #d98b16;
  background: #fff7ed;
  border-color: #f6d9b3;
}

.manual-cost-summary-cost {
  color: #2f6fdd;
  background: #eef5ff;
  border-color: #cfe0ff;
}

.manual-cost-summary-profit {
  color: #15a07a;
  background: #ecfdf5;
  border-color: #bdebd8;
}

.manual-cost-summary-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
}

.manual-cost-quick-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.manual-cost-import-upload {
  display: inline-flex;
}

.manual-cost-ratio-input {
  width: 130px;
}

.order-detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 95%;
  margin-bottom: 8px;
  flex-wrap: nowrap;
}

.order-detail-input {
  flex: 1 1 0;
  min-width: 0;
}

.order-detail-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 86px;
  white-space: nowrap;
}

.order-detail-actions .el-button + .el-button {
  margin-left: 0;
}

.manual-cost-inner-table .el-table__expanded-cell {
  padding: 0 !important;
}

.manual-cost-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.manual-cost-pagination {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.manual-cost-footer-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.manual-cost-footer-actions .el-button + .el-button {
  margin-left: 0;
}

@media (max-width: 768px) {
  .manual-cost-footer {
    flex-wrap: wrap;
  }

  .manual-cost-pagination,
  .manual-cost-footer-actions {
    width: 100%;
  }

  .manual-cost-footer-actions {
    justify-content: flex-end;
  }
}

.manual-cost-money-input {
  width: 100%;
}

.manual-cost-money-input .el-input__inner {
  padding-left: 6px;
  padding-right: 6px;
}

.manual-cost-money-input input::-webkit-outer-spin-button,
.manual-cost-money-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.manual-cost-money-color .el-input__inner,
.manual-cost-money-text {
  color: #e6a23c;
}

.manual-cost-tooltip-money {
  cursor: help;
  border-bottom: 1px dashed currentColor;
}

.bill-account-cell {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 6px;
  justify-content: center;
  line-height: 1.45;
  min-width: 0;
  overflow: visible;
  white-space: normal;
}

.bill-account-name {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-all;
}

.bill-account-icon {
  flex: 0 0 auto;
  line-height: 1;
}

.bill-prepay-tag {
  flex: 0 0 auto;
  margin-left: 0 !important;
}

.manual-cost-dialog .cell {
  white-space: nowrap;
}

.pending-price-toolbar {
  align-items: center;
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.pending-price-toolbar-actions {
  margin-left: auto;
}

.pdf-merge-selected {
  max-height: 120px;
  overflow-y: auto;
}

.pdf-merge-rule-box {
  max-height: 300px;
  overflow-y: auto;
}

.pdf-merge-rule-row {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.pdf-merge-rule-select {
  flex: 1;
  min-width: 0;
}

.pdf-merge-rule-arrow {
  color: #606266;
  flex: 0 0 auto;
  font-size: 12px;
}

@media (max-width: 768px) {
  .pdf-merge-rule-row {
    align-items: stretch;
    flex-direction: column;
  }
}

.bill-level-1-row > td {
  background-color: #fffdf7 !important;
}

.bill-level-2-row > td {
  background-color: #f8fbff !important;
}

.bill-level-3-row > td {
  background-color: #f8fff9 !important;
}

.bill-level-4-row > td {
  background-color: #fff7fb !important;
}

.bill-level-5-row > td {
  background-color: #fbf9ff !important;
}

.manual-cost-level-1-row > td {
  background-color: #f8fff9 !important;
}

.manual-cost-level-2-row > td {
  background-color: #fff7fb !important;
}

.manual-cost-level-3-row > td {
  background-color: #fbf9ff !important;
}

::v-deep(.el-table__expanded-cell) {
  overflow: visible !important;
  padding: 12px 20px !important;
}

.expand-wrapper {
  display: block;
  width: 100%;
  padding-left: 60px;
  box-sizing: border-box;
}

</style>
